// import React, { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import $ from "jquery";
// import { useLocation } from "react-router-dom";
// import {
//   Clear_invoice,
//   setothercharges,
// } from "../features/POS";
// import PosView from "./PosView";
// import Notes from "./Notes";
// import OtherCharges from "./OtherCharges";
// import CustomerSearch from "./CustomerSearch";
// import Sessionopenclose from "./Sessionopenclose";
// import Receipt from "./Receipt";
// import DeliveryOption from "./DeliveryOption";
// import Posrightmenu from "./Posrightmenu";
// import {
//   Ask_Question,
//   Pre_Loading,
//   Show_Message,
// } from "../General/Messagedialogbox";
// import Messagedialogbox from "../General/Messagedialogbox";
// import Discount from "./Discount";
// import StaffProfile from "./StaffProfile";
// import ProductReturn from "./ProductReturn";
// import POSReturn from "./POSReturn";
// import MobileProductSearch from "./MobileProductSearch";
// import {
//   API_FETCH,
//   API_POST,
//   API_POSTParem,
//   DecryptData,
// } from "../General/Utility";
// import { Update_AdminCntrl } from "../features/CommonStates";
// import {
//   AddProduct,
//   Clear_POSCustomer,
//   Clear_Transaction,
//   CustomerInput_Onchange,
//   Load_NewSession,
//   Modify_Product,
//   Modify_Vouchers,
//   Remove_product,
//   ShowHide_Popup,
//   Update_BillType,
//   setPOS_DefaultParems,
// } from "../features/Transactionstates";
// import TransProductSearch from "../Transaction/TransProductSearch";
// import BatchProductSearch from "../Transaction/BatchProductSearch";
// import AttributeProductSearch from "../Transaction/AttributeProductSearch";
// import { TransConfig } from "../Transaction/Transaction";
// import PosproductInput from "./PosproductInput";
// import ItemRemarks from "../Transaction/ItemRemarks";
// import RootCalculation from "../Transaction/RootCalculation";

// // ---------- module level helpers (no re-creation on every render) ----------
// // en-IN => lakh/crore grouping (12,34,567.00). en-GB showed 1,234,567.00 for INR.
// const INR = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" });
// const fmtINR = (v) => INR.format(Number(v) || 0);
// // dd/MM/yyyy ; empty for null / .NET default date (0001-01-01)
// const fmtDate = (v) => {
//   if (!v) return "";
//   if (typeof v === "string" && /^\d{2}[/-]\d{2}[/-]\d{4}/.test(v)) return v;
//   const d = new Date(v);
//   if (isNaN(d.getTime()) || d.getFullYear() < 1900) return "";
//   const p = (n) => String(n).padStart(2, "0");
//   return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
// };
// // Cash, Card, Bank, Wallet, UPI  (same ids the screen already used)
// const pickNum = (...vals) => {
//   for (const v of vals) {
//     if (v !== undefined && v !== null && v !== "" && !isNaN(Number(v))) return Number(v);
//   }
//   return 0;
// };
// const PAY_MODES = [2, 6, 4, 7, 8];
// const PAY_LABELS = { 2: "Cash", 6: "Card", 4: "Bank", 7: "Wallet", 8: "UPI" };
// const PAY_ICONS = {
//   2: "fa-solid fa-indian-rupee-sign",
//   6: "fa-regular fa-credit-card",
//   4: "fa-solid fa-building-columns",
//   7: "fa-solid fa-wallet",
// };

// function Pointofsales() {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const _AuthParems = useSelector((state) => state.Common.Admin);
//   const tableRef = useRef(null);
//   const buttonsave = useRef();
//   const buttoncard = useRef();
//   const buttonclear = useRef();
//   const rowRefs = useRef([]); // item table rows (keyboard navigation)
//   const payRefs = useRef([]); // payment mode buttons
//   const keyHandlerRef = useRef(null); // always points to latest key handler (no stale state)
//   const isBusyRef = useRef(false); // blocks double submit / double click

//   //#region  Redonly Parem from Global Redux Storage
//   const _Common = useSelector((store) => store.Transstates.Common);
//   const _HT = useSelector((store) => store.Transstates.Header);
//   const _DT = useSelector((state) => state.Transstates.Data);
//   const _Sum = useSelector((state) => state.Transstates.Summary);
//   const _Employee = useSelector((state) => state.Transstates.Employee);
//   const _Product = useSelector((state) => state.Transstates.Product);
//   const _Pos = useSelector((state) => state.Pointofsales.Pos);
//   const _Customer = useSelector((state) => state.Transstates.Customer);
//   // ✅ FIX: was the legacy Pointofsales.BillDiscount slice, which nothing updates any more.
//   // The Discount popup, coupon and Modify_Vouchers all write Transstates.Discount, so the bill
//   // discount was sent as 0 on Save and DROPPED whenever another product was added.
//   const _Disc = useSelector((state) => state.Transstates.Discount);
//   //#endregion

//   //#region Default parems
//   const [strSearch, setstrSearch] = useState("");
//   const [isDiscount, setisDiscount] = useState(false);
//   const [iVouchId, setiVouchId] = useState(0);
//   const [isConvertReturn, setisConvertReturn] = useState(false);
//   const [arrEntPermission, setarrEntPermission] = useState([]);
//   //#endregion

//   //#region Popup Parems
//   const [isPosView, setisPosView] = useState(false);
//   const [isAddNotes, setisAddNotes] = useState(false);
//   const [isOtherCharges, setisOtherCharges] = useState(false);
//   const [isReceipt, setisReceipt] = useState(false);
//   const [isAddtoCart, setisAddtoCart] = useState(false);
//   const [isDelivery, setisDelivery] = useState(false);
//   const [isReturn, setisReturn] = useState(false);
//   const [isProReturn, setisProReturn] = useState(false);
//   //#endregion
//   const _ScrId = 93;

//   const hasUnsavedCart = _DT.arrEntDT.length > 0 && !isAddtoCart;

//   useEffect(() => {
//     Load_PosInvoice().then((session) => {
//       // opened from the "Return" menu (/Pointofsales/POSReturn): show the Sales Return
//       // popup once the session is loaded (a running session is required to bill)
//       if (session > 0 && /\/posreturn\/?$/i.test(location.pathname)) {
//         setisReturn(true);
//       }
//     });
//     // ✅ FIX: listener registered once but it always calls the LATEST handler
//     // (before, it captured the first render's state forever -> stale isAddtoCart etc.)
//     const onKey = (e) => {
//       if (keyHandlerRef.current) keyHandlerRef.current(e);
//     };
//     document.addEventListener("keydown", onKey);
//     return () => document.removeEventListener("keydown", onKey);
//   }, []);

//   // Warn before tab close / refresh when the cashier has an unsaved bill
//   useEffect(() => {
//     if (!hasUnsavedCart) return;
//     const warn = (e) => {
//       e.preventDefault();
//       e.returnValue = "";
//     };
//     window.addEventListener("beforeunload", warn);
//     return () => window.removeEventListener("beforeunload", warn);
//   }, [hasUnsavedCart]);

//   // New bill should always start with a selected payment mode (Cash)
//   useEffect(() => {
//     if (
//       !PAY_MODES.includes(Number(_HT.iBillTypeId)) &&
//       !isAddtoCart &&
//       !isConvertReturn
//     ) {
//       dispatch(Update_BillType(2));
//     }
//   }, [_HT.iBillTypeId, isAddtoCart, isConvertReturn]);
//   const Load_PosInvoice = async () => {
//     let sessionId = 0;
//     try {
//       await Pre_Loading(dispatch, true);
//       const _LocalParems = await DecryptData(localStorage.jbctrlparams);
//       await dispatch(Update_AdminCntrl(_LocalParems));
//       sessionId = Number(_LocalParems.Session) || 0;
//       if (Number(_LocalParems.Session) === 0) {
//         const res = await API_FETCH(
//           `POS/Load_Employee/${Number(_LocalParems.Branch)}/${_LocalParems.DB}`,
//           dispatch
//         );
//         if (res) {
//           res.Counter = Number(_LocalParems.Counter);
//           await dispatch(Load_NewSession(res));
//           await dispatch(ShowHide_Popup({ isshow: "IsSession", default: true }));
//         }
//       } else {
//         const config = TransConfig(_ScrId);
//         const objTrans = await {
//           strController: config.Controller,
//           strScrType: config.strScrType,
//           iScrId: config.iScrId,
//           strScrName: config.strScrName,
//           iPartyScrId: 2,
//           iPartyId: 0,
//           iVenType: 0,
//           strSearch: "",
//           strColName: "",
//           strDBName: _LocalParems.DB,
//           iClientId: Number(_LocalParems.Client),
//           iUserId: Number(_LocalParems.User),
//           iRoleId: Number(_LocalParems.Role),
//           iBranchId: Number(_LocalParems.Branch),
//           iCounterId: Number(_LocalParems.Counter),
//           iSessionId: Number(_LocalParems.Session),
//         };
//         const res = await API_POST(`POS/Load_Invoice/`, objTrans, dispatch);
//         if (res) {
//           res.Transparem = objTrans;
//           await dispatch(setPOS_DefaultParems(res));
//         }
//       }
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//     return sessionId;
//   };

//   //#region  Click Event
//   // delivery address typed in the customer popup (or the billing address when "same as billing")
//   const Customer_ShippingAddress = () => {
//     if (!_Customer) return "";
//     if (!_Customer.IsSameAdd) return String(_Customer.ShippAdd || "").trim();
//     return [_Customer.Address1, _Customer.Address2, _Customer.Address3, _Customer.Address4, _Customer.Pincode]
//       .map((x) => String(x || "").trim())
//       .filter(Boolean)
//       .join(", ");
//   };
//   const Save_Invoice = async (isHoldInvoice, ObjReceipt) => {
//     let ReceiptDt = {};
//     let URL = "POS/InsUpd_Invoice/";
//     if (isHoldInvoice === false) {
//       ReceiptDt = {
//         strPrefix: "",
//         iNumSeqNo: 0,
//         strCompCode: "",
//         strFinanFrom: "",
//         strRecNo: "",
//         strTransNo: "",
//         dpRecDate: _HT.strVouchDate,
//         iVenType: 5,
//         iVenId: Number(_Customer.PartyId) || Number(_HT.iPartyId) || 0,
//         iPayModeId: _HT.iBillTypeId,
//         dAmount: ObjReceipt.dAmount,
//         iVouchId: 0,
//         iBankAccId: ObjReceipt.iBankAccId,
//         strChequeNo: ObjReceipt.strChequeNo,
//         dpChequeDate: ObjReceipt.strChequeDate,
//         strAccNo: ObjReceipt.strAccNo,
//         strAccHolderName: ObjReceipt.strAccHolderName,
//         strPrintName: ObjReceipt.strPrintName,
//         strRemark: ObjReceipt.strRemark,
//         iBNId: ObjReceipt.iBankId,
//         iRecId: 0,
//         iCallerScrId: 93,
//         strBankName: "",
//         strFilter: "",
//         strFilterColumn: "",
//         strSearch: "",
//         strVenName: "",
//         strDBName: _AuthParems.DB,
//         iSessionId: Number(_AuthParems.Session),
//       };
//     } else {
//       URL = "POS/InsUpd_Cart/"; // Hold Invoice
//       ReceiptDt = {
//         strPrefix: "",
//         iNumSeqNo: 0,
//         strCompCode: "",
//         strFinanFrom: "",
//         strRecNo: "",
//         strTransNo: "",
//         dpRecDate: _HT.strVouchDate,
//         iVenType: 5,
//         iVenId: 0,
//         iPayModeId: 0,
//         dAmount: 0,
//         iVouchId: 0,
//         iBankAccId: 0,
//         strChequeNo: "",
//         dpChequeDate: _HT.strVouchDate,
//         strAccNo: "",
//         strAccHolderName: "",
//         strPrintName: "",
//         strRemark: "",
//         iBNId: 0,
//         iRecId: 0,
//         iCallerScrId: 0,
//         strBankName: "",
//         strFilter: "",
//         strFilterColumn: "",
//         strSearch: "",
//         strVenName: "",
//         strDBName: "",
//         iSessionId: 0,
//       };
//     }
//     const POSInvListHT = {
//       iPosInvId: _HT.iVouchId,
//       iTitleTag: _Common.iScrId,
//       // customer picked in the popup wins; else the bill's own party (modify bill)
//       iPartyId: Number(_Customer.PartyId) || Number(_HT.iPartyId) || 0,
//       strShippingAdd: Customer_ShippingAddress() || _HT.strShippingAdd,
//       iNumSeqNo: 0,
//       strPrefix: "",
//       strCompCode: "",
//       strFinanFrom: "",
//       strTransNo: "",
//       strVouchNo: _HT.strVouchNo,
//       strVouchDate: _HT.strVouchDate,
//       iAddLessBillDiscId: Number(_Common.iALBillDiscId) || 0,
//       iBillTypeId: _HT.iBillTypeId,
//       iTaxCalcOnId: Number(_Common.iTaxCalcOnId) || 0,
//       iTaxTypeId: Number(_HT.iTaxRelId),
//       iDMId: _HT.iDMId,
//       strConvertDCVouch: _HT.strConvertDCVouch,
//       strPartyDCVouch: _HT.strPartyDCVouch,
//       strRefNum1: _HT.strRefNum1,
//       dpRefNum1Date: _HT.dpRefNum1Date,
//       strRefNum2: _HT.strRefNum2,
//       dpRefNum2Date: _HT.dpRefNum2Date,
//       strRefNum3: _HT.strRefNum3,
//       dpRefNum3Date: _HT.dpRefNum3Date,
//       strRefNum4: _HT.strRefNum4,
//       dpRefNum4Date: _HT.dpRefNum4Date,
//       strRemark1: _HT.strRemark1,
//       strRemark2: _HT.strRemark2,
//       strRemark3: _HT.strRemark3,
//       strRemark4: _HT.strRemark4,
//       strValidity: String(_HT.strValidity || "0"),
//       dpValDateUpto: _HT.dpValDateUpto,
//       strPayTerm: String(_HT.strPayTerm || "0"),
//       dpPayTermDateUpto: _HT.dpPayTermDateUpto,
//       strDeliTerm: String(_HT.strDeliTerm || "0"),
//       dpDelTermDateUpto: _HT.dpDelTermDateUpto,

//       strEComGstNo: _HT.strEComGstNo,
//       strTransport: _HT.strTransport,
//       strVehicle: _HT.strVehicle,
//       strDespatch: _HT.strDespatch,
//       dpDespatchDate: _HT.dpDespatchDate,
//       strLRNNumber: _HT.strLRNNumber,
//       dpLRNoDate: _HT.dpLRNoDate,
//       strAgent: _HT.strAgent,
//       strReference: _HT.strReference,
//       strDestination: _HT.strDestination,

//       dTBillDiscPer: Number(_Disc.dBillDisPer),
//       dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//       dTBillDiscValue: Number(_Disc.dBillDisValue),
//       dTAddLessDiscPer: Number(_Disc.dALBillDisPer),
//       dTAddLessDiscAmt: Number(_Disc.dALBillDisAmt),
//       dTAddLessDiscValue: Number(_Disc.dALBillDisValue),

//       dTotQty: Number(_Sum.Qty),
//       dTotGoodval: Number(_Sum.GoodsValue),
//       dTotDiscount: Number(_Sum.Discount),
//       dTotTax: Number(_Sum.Tax),
//       dAddLess: Number(_Sum.AddLess),
//       dTotTCSTax: Number(_Sum.TCSTax),
//       dRoundOff: Number(_Sum.RoundOff),
//       dNetAmt: Number(_Sum.NetAmt),
//       // paid / balance come from the receipt (the invoice header used to store 0 / 0)
//       dPaidAmt: isHoldInvoice ? 0 : Number(ObjReceipt && ObjReceipt.dAmount) || 0,
//       dBalAmt: isHoldInvoice
//         ? Number(_Sum.NetAmt)
//         : Math.max(
//             0,
//             Math.round((Number(_Sum.NetAmt) - (Number(ObjReceipt && ObjReceipt.dAmount) || 0)) * 100) / 100
//           ),
//       dRoyaltyPoint: Number(_Disc.dRewardPointAmt),
//       iCouponId: Number(_Disc.iCouponId),
//       iCartInvId: _HT.iCartInvId,
//       iUserId: Number(_AuthParems.User),
//       iEmpId: Number(_Employee.iEmpId),
//       FYid: Number(_AuthParems.Year),
//       strDBName: _AuthParems.DB,
//       iSessionId: Number(_AuthParems.Session),
//       iBranchId: Number(_AuthParems.Branch),
//     };
//     const objCust = {
//       PartyId: _Customer.PartyId,
//       PartyName: _Customer.PartyName,
//       PartyCode: _Customer.PartyCode,
//       AliasName: _Customer.AliasName,
//       Address1: _Customer.Address1,
//       Address2: _Customer.Address2,
//       Address3: _Customer.Address3,
//       Address4: _Customer.Address4,
//       State: _Customer.State,
//       Country: _Customer.Country,
//       Pincode: _Customer.Pincode,
//       Mobile: _Customer.Mobile,
//       Phone: _Customer.Phone,
//       Email: _Customer.Email,
//       GST: _Customer.GST,
//       Remark: _Customer.Remark,
//       RoyaltyPoint: _Customer.RoyaltyPoint,
//       ShippAdd: _Customer.ShippAdd,
//       IsSameAdd: _Customer.IsSameAdd,
//       Status: _Customer.Status,
//       CreatedBy: _Customer.CreatedBy,
//       RewardType: _Customer.RewardType,
//       // ✅ FIX: the API model is PosCustomerMasterModel (iCustId, strCustName,
//       // strAdd1-4, strPincode, iCountry, iState, strMobile1/2, strEmail,
//       // dRoyaltyPoint). None of the keys above exist on it, so the customer
//       // typed / selected in the popup was silently dropped by the JSON binder.
//       iCustId: Number(_Customer.PartyId) || 0,
//       strCustName: _Customer.PartyName,
//       strAdd1: _Customer.Address1,
//       strAdd2: _Customer.Address2,
//       strAdd3: _Customer.Address3,
//       strAdd4: _Customer.Address4,
//       strPincode: _Customer.Pincode,
//       iCountry: Number(_Customer.CountryId) || 0,
//       iState: Number(_Customer.StateId) || 0,
//       strMobile1: _Customer.Mobile,
//       strMobile2: _Customer.Phone,
//       strEmail: _Customer.Email,
//       dRoyaltyPoint: Number(_Customer.RoyaltyPoint) || 0,
//     };
//     const res = await API_POST(
//       URL,
//       {
//         objEntPos: POSInvListHT,
//         objTransDT: _DT.arrEntDT,
//         objDTHelp: _DT.arrEntDTHelp,
//         objEntALDT: _DT.arrEntAL,
//         objEntTax: _DT.arrEntTax,
//         objEntCust: objCust,
//         objEntReceipt: ReceiptDt,
//       },
//       dispatch
//     );
//     if (res) {
//       Show_Message(dispatch, res.strMessage, "success");
//       await CancelInvoice();
//     }
//   };
//   const InsUpd_Return = async () => {
//     const ReturnHT = {
//       iPOSRetId: _HT.iVouchId,
//       iTitleTag: 96,
//       // customer picked in the popup wins; else the bill's own party (modify bill)
//       iPartyId: Number(_Customer.PartyId) || Number(_HT.iPartyId) || 0,
//       strShippingAdd: _HT.strShippingAdd,
//       strVouchNo: _HT.strVouchNo,
//       strVouchDate: _HT.strVouchDate,
//       iAddLessBillDiscId: Number(_Common.iALBillDiscId) || 0,
//       iBillTypeId: _HT.iBillTypeId,
//       iTaxCalcOnId: Number(_Common.iTaxCalcOnId) || 0,
//       iTaxTypeId: Number(_HT.iTaxRelId),
//       iDMId: _HT.iDMId,
//       strConvertDCVouch: _HT.strConvertDCVouch,
//       strPartyDCVouch: _HT.strPartyDCVouch,
//       strRefNum1: _HT.strRefNum1,
//       dpRefNum1Date: _HT.dpRefNum1Date,
//       strRefNum2: _HT.strRefNum2,
//       dpRefNum2Date: _HT.dpRefNum2Date,
//       strRefNum3: _HT.strRefNum3,
//       dpRefNum3Date: _HT.dpRefNum3Date,
//       strRefNum4: _HT.strRefNum4,
//       dpRefNum4Date: _HT.dpRefNum4Date,
//       strRemark1: _HT.strRemark1,
//       strRemark2: _HT.strRemark2,
//       strRemark3: _HT.strRemark3,
//       strRemark4: _HT.strRemark4,
//       strValidity: String(_HT.strValidity || "0"),
//       dpValDateUpto: _HT.dpValDateUpto,
//       strPayTerm: String(_HT.strPayTerm || "0"),
//       dpPayTermDateUpto: _HT.dpPayTermDateUpto,
//       strDeliTerm: String(_HT.strDeliTerm || "0"),
//       dpDelTermDateUpto: _HT.dpDelTermDateUpto,

//       strEComGstNo: _HT.strEComGstNo,
//       strTransport: _HT.strTransport,
//       strVehicle: _HT.strVehicle,
//       strDespatch: _HT.strDespatch,
//       dpDespatchDate: _HT.dpDespatchDate,
//       strLRNNumber: _HT.strLRNNumber,
//       dpLRNoDate: _HT.dpLRNoDate,
//       strAgent: _HT.strAgent,
//       strReference: _HT.strReference,
//       strDestination: _HT.strDestination,

//       dTBillDiscPer: Number(_Disc.dBillDisPer),
//       dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//       dTBillDiscValue: Number(_Disc.dBillDisValue),
//       dTAddLessDiscPer: Number(_Disc.dALBillDisPer),
//       dTAddLessDiscAmt: Number(_Disc.dALBillDisAmt),
//       dTAddLessDiscValue: Number(_Disc.dALBillDisValue),

//       dTotQty: Number(_Sum.Qty),
//       dTotGoodval: Number(_Sum.GoodsValue),
//       dTotDiscount: Number(_Sum.Discount),
//       dTotTax: Number(_Sum.Tax),
//       dAddLess: Number(_Sum.AddLess),
//       dTotTCSTax: Number(_Sum.TCSTax),
//       dRoundOff: Number(_Sum.RoundOff),
//       dNetAmt: Number(_Sum.NetAmt),
//       dRoyaltyPoint: Number(_Disc.dRewardPointAmt),
//       iCouponId: Number(_Disc.iCouponId),
//       iCartInvId: _HT.iCartInvId,
//       iUserId: Number(_AuthParems.User),
//       iEmpId: Number(_Employee.iEmpId),
//       FYid: Number(_AuthParems.Year),
//       strDBName: _AuthParems.DB,
//       iSessionId: Number(_AuthParems.Session),
//       iBranchId: Number(_AuthParems.Branch),
//     };
//     const res = await API_POST(
//       "POS/InsUpd_Return",
//       {
//         objEntPos: ReturnHT,
//         objBaseTransDT: _DT.arrEntDT,
//         objDTHelp: _DT.arrEntDTHelp,
//         objEntALDT: _DT.arrEntAL,
//         objEntTax: _DT.arrEntTax,
//       },
//       dispatch
//     );
//     if (res) {
//       Show_Message(dispatch, res.strMessage, "success");
//       await CancelInvoice();
//     }
//   };
//   const Delete_PosInvoice = async () => {
//     const res = await API_POSTParem(
//       `POS/Delete_Invoice/${Number(_HT.iVouchId)}/${Number(
//         _AuthParems.Branch
//       )}/${_AuthParems.DB}`,
//       dispatch
//     );
//     if (res) {
//       Show_Message(dispatch, res.strMessage, "success");
//       await CancelInvoice();
//     }
//   };
//   const Delete_Return = async () => {
//     const res = await API_POSTParem(
//       `POS/Delete_Return/${Number(_HT.iVouchId)}/${Number(
//         _AuthParems.Branch
//       )}/${_AuthParems.DB}`,
//       dispatch
//     );
//     if (res) {
//       Show_Message(dispatch, res.strMessage, "success");
//       await CancelInvoice();
//     }
//   };
//   const CancelInvoice = async () => {
//     setisAddtoCart(false);
//     setisConvertReturn(false);
//     setisReceipt(false);
//     dispatch(Clear_invoice()); // legacy slice (BillDiscount / Pos)
//     // ✅ FIX: cart, header, summary and customer live in Transstates; only the
//     // legacy slice was cleared, so after Save / Clear the old bill stayed on screen.
//     dispatch(Clear_Transaction());
//     dispatch(Clear_POSCustomer());
//     await Load_PosInvoice();
//   };
//   // Runs one server action at a time: loader on/off, errors shown, no double submit.
//   const runGuarded = async (fn) => {
//     if (isBusyRef.current) return;
//     isBusyRef.current = true;
//     try {
//       await Pre_Loading(dispatch, true);
//       await fn();
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//       isBusyRef.current = false;
//     }
//   };
//   // Ask before throwing away an unsaved cart
//   const confirmDiscardCart = (next, msg) => {
//     if (_DT.arrEntDT.length > 0 && !isAddtoCart && !isConvertReturn) {
//       Ask_Question(
//         dispatch,
//         next,
//         msg || "Current invoice has unsaved items. Do you want to discard them?",
//         true
//       );
//     } else {
//       next();
//     }
//   };
//   const Clear_Click = () => {
//     if (_DT.arrEntDT.length > 0 && !isAddtoCart) {
//       Ask_Question(
//         dispatch,
//         CancelInvoice,
//         "Clear the current invoice? All items will be removed.",
//         true
//       );
//     } else {
//       CancelInvoice();
//     }
//   };
//   const Show_Receipt = () => {
//     setisReceipt(true);
//   };
//   const Save_Click = () => {
//     if (_DT.arrEntDT.length === 0) {
//       Show_Message(dispatch, "At least one item is required", "info");
//     } else if (Number(_AuthParems.Session) === 0) {
//       Show_Message(dispatch, "Please start a session before billing", "info");
//       if (!_Common.IsSession) dispatch(ShowHide_Popup("IsSession"));
//     } else if (isConvertReturn) {
//       // ✅ FIX: "Save Return" used to open the receipt and post to the SALES
//       // invoice endpoint. InsUpd_Return existed but was never called.
//       Ask_Question(
//         dispatch,
//         () => runGuarded(InsUpd_Return),
//         `Do You Want to Save "Return"?`
//       );
//     } else if (Number(_Sum.NetAmt) < 0) {
//       Show_Message(dispatch, "Net amount cannot be negative", "info");
//     } else if (Number(_HT.iBillTypeId) === 0) {
//       Show_Message(dispatch, "Bill Type is Required", "info");
//     } else {
//       Ask_Question(dispatch, Show_Receipt, `Do You Want to Save "Invoice"?`);
//     }
//   };
//   //#endregion

//   //#region  View Methods
//   const View_posinvoice = (vouchid) =>
//     confirmDiscardCart(
//       () => runGuarded(() => Load_SelectedInvoice(vouchid)),
//       "Current invoice has unsaved items. Discard them and open the selected invoice?"
//     );
//   const Load_SelectedInvoice = async (vouchid) => {
//     const res = await API_FETCH(
//       `POS/View_VoucherDetails/${vouchid}/93/${Number(_AuthParems.Branch)}/${
//         _AuthParems.DB
//       }`,
//       dispatch
//     );
//     if (res) {
//       setisPosView(false);
//       // Add To Cart Not Allowed When Modify Bill
//       setisAddtoCart(true);
//       let _EntHT = res.objEntHT[0];
//       let _EntService = res.EntService;
//       let summary = res.objEntSummary;
//       // ✅ FIX: the screen reads Transstates (Header / Data / Summary / Customer).
//       // The old code dispatched legacy features/POS actions, so the opened bill
//       // never reached the screen: _HT.iVouchId stayed 0 (Delete disabled and Save
//       // would create a NEW invoice instead of modifying this one).
//       dispatch(
//         Modify_Vouchers({
//           VouchId: _EntHT.iPosInvId,
//           Data: {
//             EntHT: [
//               {
//                 ..._EntHT,
//                 strPartyName: res.objPartyList[0],
//                 billAdd: res.objPartyList[1],
//                 shippAdd: _EntHT.strShippingAdd,
//                 isAccess:
//                   _EntHT.bCancelStatus !== true && res.objCanAccess !== false,
//               },
//             ],
//             EntDT: res.objEntDT,
//             EntTax: res.objEntTax,
//             EntPenCon: [],
//             EntAL: res.objEntALDT,
//             EntDTHelp: res.objEntDTHelp,
//             Summary: summary,
//           },
//         })
//       );
//       [
//         ["PartyId", _EntHT.iPartyId],
//         ["PartyName", res.objPartyList[0]],
//         ["Mobile", res.objPartyList[2]],
//         ["GST", res.objPartyList[3]],
//         ["ShippAdd", _EntHT.strShippingAdd],
//         ["RoyaltyPoint", Number(_EntHT.dRoyaltyPoint) || 0],
//       ].forEach(([Name, Value]) =>
//         dispatch(CustomerInput_Onchange({ Name, Value }))
//       );
//       dispatch(
//         setothercharges({
//           SerId: 0,
//           ServiceName: "",
//           SerCode: "",
//           SACcode: "",
//           bUpdateStatus: false,
//           iRowIndex: 0,
//           RateWithoutTax: (0).toFixed(2),
//           RateWithTax: (0).toFixed(2),
//           dTaxPer: 0,
//           EntALTax: _EntService._EntServiceTax,
//         })
//       );
//     }
//   };
//   //#endregion

//   //#region Common Methods

//   // ✅ FIX: was jQuery toggleClass("active") -> clicking the selected mode again
//   // un-highlighted everything, F4 never cycled, and "Clear Invoice" left the old
//   // highlight while redux had been reset. Highlight now comes from redux state.
//   const Update_PaymentMode = (PayId) => {
//     dispatch(Update_BillType(PayId));
//     const idx = PAY_MODES.indexOf(PayId);
//     if (payRefs.current[idx]) payRefs.current[idx].focus();
//   };
//   const Next_PaymentMode = (step) => {
//     const cur = PAY_MODES.indexOf(Number(_HT.iBillTypeId));
//     const next = (cur + step + PAY_MODES.length) % PAY_MODES.length;
//     Update_PaymentMode(PAY_MODES[next]);
//   };
//   const validatename = (columnName) => {
//     switch (columnName) {
//       case "proName":
//       case "unitName":
//       case "attValues":
//       case "taxPer":
//         return false;
//       default:
//         return true;
//     }
//   };
//   const validatedatatype = (columnName, DataType) => {
//     switch (columnName) {
//       case "manufactureDate":
//       case "expiryDate":
//         return "Date";
//       default:
//         if (DataType === "Decimal") return "number";
//         else return "text";
//     }
//   };
//   const converttodecimal = (type, value, len) => {
//     switch (type) {
//       case "Decimal":
//         return Number(value).toFixed(len);
//       case "Int32":
//         return Number(value);
//       default:
//         return value;
//     }
//   };
//   const numtodecimal = (num) => {
//     return Number(num).toFixed(2);
//   };
//   const isTypingTarget = (el) =>
//     !!el &&
//     (el.tagName === "INPUT" ||
//       el.tagName === "TEXTAREA" ||
//       el.tagName === "SELECT" ||
//       el.isContentEditable);
//   const anyPopupOpen = () =>
//     isPosView || isAddNotes || isOtherCharges || isReceipt || isDelivery ||
//     isReturn || isProReturn || isDiscount || _Common.IsPOSCustomer ||
//     _Common.IsEmployee || _Common.IsPosPro || _Common.IsProRemark ||
//     _Common.IsProCal || _Common.IsSession || _Common.IsProSearch ||
//     _Common.IsBatchPro || _Common.IsAttPro;
//   const focusRow = (i) => {
//     const el = rowRefs.current[i];
//     if (el) el.focus();
//   };
//   const Open_RightMenu = () => {
//     if (!_Common.IsRightMenu) dispatch(ShowHide_Popup("IsRightMenu"));
//     setTimeout(() => $("#pos-menu").addClass("active"), 0);
//   };
//   const Open_ProductSearch = () => {
//     if (Number(_AuthParems.Session) === 0) {
//       Show_Message(dispatch, "Please start a session before billing", "info");
//       if (!_Common.IsSession) dispatch(ShowHide_Popup("IsSession"));
//       return;
//     }
//     if (!_Common.IsProSearch) dispatch(ShowHide_Popup("IsProSearch"));
//   };
//   const short_cut_keypress = (e) => {
//     if (e.repeat) return; // holding a key used to toggle popups open/close/open...
//     const key = (e.key || "").toLowerCase();
//     const ctrl = e.ctrlKey || e.metaKey;
//     const popupOpen = anyPopupOpen();

//     // Ctrl+S must never reach the browser "Save page" dialog
//     if (ctrl && key === "s") {
//       e.preventDefault();
//       if (!popupOpen && buttonsave.current && !buttonsave.current.disabled) {
//         buttonsave.current.click();
//       }
//       return;
//     }
//     if (popupOpen) return; // no shortcuts underneath an open popup

//     if (ctrl && e.shiftKey) {
//       // ✅ FIX: ANY Ctrl+Shift combo (even Ctrl+Shift+Tab / DevTools keys)
//       // used to reload the page and wipe the bill. Now only Ctrl+Shift+R.
//       if (key === "r") {
//         e.preventDefault();
//         window.location.reload();
//       }
//       return;
//     }
//     if (ctrl) {
//       if (key === "h" && buttoncard.current && !isAddtoCart) {
//         // Hold invoice (only if a Hold button is actually rendered)
//         e.preventDefault();
//         buttoncard.current.click();
//       } else if (key === "e") {
//         e.preventDefault();
//         if (buttonclear.current) buttonclear.current.click();
//       } else if (key === "a" && !isTypingTarget(e.target)) {
//         // keep Ctrl+A = "select all" while typing in a text box
//         e.preventDefault();
//         Open_RightMenu();
//       }
//       return;
//     }
//     switch (e.key) {
//       case "F1": {
//         e.preventDefault();
//         const box = document.getElementById("pro-search");
//         if (box) {
//           box.focus();
//           box.select();
//         }
//         Open_ProductSearch();
//         break;
//       }
//       case "F2":
//         e.preventDefault();
//         if (!isConvertReturn) dispatch(ShowHide_Popup("IsPOSCustomer"));
//         break;
//       case "F3":
//         e.preventDefault();
//         dispatch(ShowHide_Popup("IsSession"));
//         break;
//       case "F4":
//         e.preventDefault();
//         Next_PaymentMode(1); // cycle Cash > Card > Bank > Wallet > UPI > Cash
//         break;
//       case "F5":
//         e.preventDefault();
//         if (_DT.arrEntDT.length > 0) focusRow(0);
//         else {
//           const box = document.getElementById("pro-search");
//           if (box) box.focus();
//         }
//         break;
//       case "F6":
//         e.preventDefault();
//         setisPosView(true);
//         break;
//       case "F8":
//         e.preventDefault();
//         if (_DT.arrEntDT.length > 0) setisDiscount(true);
//         break;
//       case "F9":
//         e.preventDefault();
//         if (_DT.arrEntDT.length > 0) setisAddNotes(true);
//         break;
//       default:
//         break;
//     }
//   };
//   // ✅ FIX: old table_keypress was called as (e, trIndex) with rowIndex undefined
//   // (Delete sent iRowIndex=undefined to the server), assumed <input>s inside the
//   // cells (there are none) and rows were not focusable, so it never ran.
//   const row_keypress = (e, product, idx) => {
//     const len = _DT.arrEntDT.length;
//     switch (e.key) {
//       case "ArrowDown":
//         e.preventDefault();
//         focusRow((idx + 1) % len);
//         break;
//       case "ArrowUp":
//         e.preventDefault();
//         focusRow((idx - 1 + len) % len);
//         break;
//       case "Enter":
//         e.preventDefault();
//         View_ProductUnit(product, idx);
//         break;
//       case "Delete":
//         e.preventDefault();
//         Confirm_Remove(idx);
//         break;
//       default:
//         break;
//     }
//   };
//   const Confirm_Remove = (idx) => {
//     const item = _DT.arrEntDT[idx];
//     const name = item && item.proName ? item.proName : "this item";
//     Ask_Question(
//       dispatch,
//       () => runGuarded(() => Remove_tableProduct(idx)),
//       `Remove "${name}" from the invoice?`,
//       true
//     );
//   };
//   // ✅ FIX: the "Attribute" column was configured but always empty
//   // (validatename() excluded attValues and nothing rendered it).
//   const hasAttCol = (_Common.arrtransper || []).some(
//     (c) => c.columnName === "attValues"
//   );
//   const Render_Cell = (dt, product) => {
//     const val = product[dt.columnName];
//     if (dt.columnName === "attValues") return val || "";
//     if (dt.columnName === "manufactureDate" || dt.columnName === "expiryDate")
//       return fmtDate(val);
//     return converttodecimal(dt.datatype, val, 2);
//   };
//   const textalign = ["left", "right", "center"];

//   //#endregion

//   //#region  Product Methods
//   const Add_NewProduct = async (Product, BatchPro) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const ProInfo = Product.ProInfo ? Product.ProInfo[0] : Product;
//       if (!ProInfo || !ProInfo.strProName) {
//         await Show_Message(dispatch, "Please Select Product", "info");
//       } else if (Number(ProInfo.dQty) <= 0) {
//         await Show_Message(
//           dispatch,
//           "Quantity must be greater than zero",
//           "info"
//         );
//       } else {
//         const parems = {
//           bUpdateStatus: false,
//           iScrId: _Common.iScrId,
//           iTaxRelId: _HT.iTaxRelId,
//           iPartyId: _HT.iPartyId,
//           iVouchId: _HT.iVouchId,
//           iTaxCalcOnId: _Common.iTaxCalcOnId,
//           iProId: ProInfo.iProId,
//           strJobId: "0",
//           iSerId: 0,
//           iRowIndex: 0,
//           iUnitId: Number(ProInfo.iUnitId),
//           dQty: Number(ProInfo.dQty),
//           FQty: Number(ProInfo.dFQty),
//           // ✅ FIX: a product picked from search comes back as Product.ProInfo; the old code read
//           // rate / discount from _Product (the edit popup's state = the PREVIOUS product / zeros).
//           dPriceRate: pickNum(ProInfo.dRateWithoutTax, ProInfo.dRate, _Product.dRate),
//           dPriceRateWithTax: pickNum(ProInfo.dRateWithTax, ProInfo.dRatewithTax, _Product.dRatewithTax),
//           dDiscountPer: Product.ProInfo
//             ? pickNum(ProInfo.dItemDiscPer)
//             : _Product.isItemDiscPer ? Number(_Product.dItemDisc) : 0,
//           dDiscountAmt: Product.ProInfo ? 0 : _Product.isItemDiscPer ? 0 : Number(_Product.dItemDisc),
//           dCashDiscountPer:
//             !Product.ProInfo && _Product.isCashDiscPer === true ? Number(_Product.dCashDisc) : 0,
//           dCashDiscountAmt:
//             !Product.ProInfo && _Product.isCashDiscPer === false ? Number(_Product.dCashDisc) : 0,
//           BatchNo: BatchPro ? BatchPro.batchNo : ProInfo.batchNo,
//           ManufactureDate: BatchPro ? BatchPro.mftDate : ProInfo.mftDate,
//           ExpiryDate: BatchPro ? BatchPro.expDate : ProInfo.expDate,
//           isComposPro: Number(ProInfo.isComposPro),
//           isBatchPro: Number(ProInfo.isBatchPro),
//           objBaseTransDT: _DT.arrEntDT,
//           objItemRemark: _Product.Remarks,
//           objRootCalc: _Product.Calculation,
//           objPenCon: _DT.arrEntPenCon,
//           objEntAddLess: _DT.arrEntAL,
//           objEntConRow: [],
//           objEntTax: _DT.arrEntTax,
//           strSearch: "",
//           strColumn: "",
//           Reason: "",
//           DimAttDTId: "0",
//           iALBillDiscId: _Common.iALBillDiscId,
//           strSetCurrentStatus: _Common.strCurrentStatus,
//           dAddLessDiscValue: Number(_Disc.dALBillDisValue),
//           dTBillDiscPer: Number(_Disc.dBillDisPer),
//           dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//           dCouponDiscPer: Number(_Disc.dCouponDiscPer),
//           dRewardPointper: Number(_Disc.dRewardPointper),
//           dCouponDiscAmt: Number(_Disc.dCouponDiscAmt),
//           dRewardPointAmt: Number(_Disc.dRewardPointAmt),
//           iYearId: Number(_AuthParems.Year),
//           iBranchId: Number(_AuthParems.Branch),
//           strDBName: _AuthParems.DB,
//           iUserid: Number(_AuthParems.User),
//         };
//         const res = await API_POST(
//           `ProductTrans/AddUpd_Product/`,
//           parems,
//           dispatch
//         );
//         if (res) {
//           await dispatch(AddProduct(res));
//           setTimeout(() => focusRow(res.EntDT.length - 1), 50);
//         }
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       // ✅ FIX: this was `Pre_Loading(dispatch, true)` — turning the loading
//       // overlay back ON instead of OFF after every product add, leaving the
//       // POS screen stuck in a "loading" state until something else happened
//       // to clear it.
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const View_ProductUnit = async (ProInfo, Index) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const res = await API_FETCH(
//         `ProductTrans/View_ProductUnit/${ProInfo.proId}/${_Common.strScrType}/${_AuthParems.DB}`,
//         dispatch
//       );
//       if (res) {
//         await dispatch(
//           Modify_Product({
//             ProInfo: ProInfo,
//             Unit: res.ProUnit,
//             Index: Index,
//           })
//         );
//         await dispatch(ShowHide_Popup("IsPosPro"));
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const Remove_tableProduct = async (iIndex) => {
//     try {
//       const res = await API_POST(
//         `ProductTrans/Delete_tableProduct/`,
//         {
//           iRowIndex: iIndex,
//           iScrId: _Common.iScrId,
//           iALBillDiscId: _Common.iALBillDiscId,
//           iTaxCalcOnId: _Common.iTaxCalcOnId,

//           iTaxRelId: _HT.iTaxRelId,
//           iPartyId: _HT.iPartyId,
//           iVouchId: _HT.iVouchId,

//           iProId: 0,
//           iUnitId: 0,
//           dQty: 0,
//           dPriceRate: 0,
//           dDiscountPer: 0,
//           dDiscountAmt: 0,

//           strSearch: "",
//           strColumn: "",
//           strReason: "",
//           strJobId: "0",
//           strSetCurrentStatus: "",

//           strProAttDTId: "",
//           strStoAttDTId: "",
//           strTraAttDTId: "",
//           objItemRemark: {},
//           objRootCalc: {},

//           dAddLessDiscValue: _Disc.dALBillDisValue,
//           dTBillDiscPer: Number(_Disc.dBillDisPer),
//           dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//           dCouponDiscPer: Number(_Disc.dCouponDiscPer),
//           dRewardPointper: Number(_Disc.dRewardPointper),
//           dCouponDiscAmt: Number(_Disc.dCouponDiscAmt),
//           dRewardPointAmt: Number(_Disc.dRewardPointAmt),

//           objPenCon: _DT.arrEntPenCon,
//           objBaseTransDT: _DT.arrEntDT,
//           objEntAddLess: _DT.arrEntAL,
//           objEntConRow: [],
//           objEntTax: _DT.arrEntTax,

//           iYearId: Number(_AuthParems.Year),
//           iBranchId: Number(_AuthParems.Branch),
//           strDBName: _AuthParems.DB,
//           iUserId: Number(_AuthParems.User),
//         },
//         dispatch
//       );
//       if (res) {
//         dispatch(Remove_product(res));
//       }
//     } catch (e) {
//       await Show_Message(dispatch, e.message, "error");
//     }
//   };

//   //#endregion

//   keyHandlerRef.current = short_cut_keypress;

//   return (
//     <div className="container-pos">
//       <div className="pos-wrapper">
//         <div className="possection">
//           {/* ✅ FIX: PC screen had NO search box (only the hidden F1 key). */}
//           {!isConvertReturn && (
//             <div className="search-product">
//               <div className="search-box">
//                 <input
//                   type="text"
//                   placeholder="Search Product or Scan Barcode (F1)"
//                   defaultValue={strSearch}
//                   onClick={() => Open_ProductSearch()}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       Open_ProductSearch();
//                     } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
//                       e.preventDefault();
//                       if (_Common.IsTabletMode) $("[tabindex=0]").focus();
//                       else focusRow(0);
//                     }
//                   }}
//                   autoFocus
//                   autoComplete="off"
//                   id="pro-search"
//                 />
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </div>
//             </div>
//           )}
//           {isConvertReturn && <h3 className="return-product">Product Return</h3>}
//           {!_Common.IsTabletMode && (
//             <div className="pos-itemlist">
//               <table className="product-table" ref={tableRef}>
//                 <thead>
//                   <tr>
//                     {(_Common.arrtransper || []).map((dt, Index) => (
//                       <th
//                         key={Index}
//                         style={{
//                           minWidth: dt.colLen + "px",
//                           maxWidth: dt.colLen + "px",
//                         }}
//                       >
//                         {dt.aliasName}
//                       </th>
//                     ))}
//                     <th style={{ width: "40px", minWidth: "40px" }}></th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {_DT.arrEntDT.map((product, trIndex) => (
//                     <tr
//                       key={trIndex}
//                       ref={(el) => (rowRefs.current[trIndex] = el)}
//                       tabIndex={-1}
//                       onClick={(e) => {
//                         View_ProductUnit(product, trIndex);
//                       }}
//                       onKeyDown={(e) => row_keypress(e, product, trIndex)}
//                     >
//                       {(_Common.arrtransper || []).map((dt, tdIndex) => (
//                         <td
//                           key={tdIndex}
//                           style={{
//                             minWidth: dt.colLen + "px",
//                             maxWidth: dt.colLen + "px",
//                             // ✅ FIX: "wrap" is not a valid CSS value -> use "normal"
//                             whiteSpace: dt.isWordwrap ? "normal" : "nowrap",
//                             textAlign: textalign[dt.textAlign - 1],
//                           }}
//                         >
//                           {dt.columnName === "proName" && (
//                             <>
//                               {`${product.proName}`}
//                               <br />
//                               <span>
//                                 GST - {numtodecimal(product.taxPer)} % | Unit :{" "}
//                                 {product.unitName}
//                                 {/* attribute goes in the sub-line only when the
//                                     grid has no "Attribute" column of its own */}
//                                 {!hasAttCol && product.attValues
//                                   ? ` | ${product.attValues}`
//                                   : ""}
//                               </span>
//                             </>
//                           )}
//                           {(validatename(dt.columnName) === true ||
//                             dt.columnName === "attValues") && (
//                             <>{Render_Cell(dt, product)}</>
//                           )}
//                         </td>
//                       ))}
//                       <td style={{ width: "40px", minWidth: "40px" }}>
//                         <button
//                           type="button"
//                           title="Remove item (Delete)"
//                           aria-label="Remove item"
//                           style={{
//                             background: "transparent",
//                             border: "none",
//                             color: "#d9534f",
//                             cursor: "pointer",
//                           }}
//                           onClick={(e) => {
//                             e.stopPropagation();
//                             Confirm_Remove(trIndex);
//                           }}
//                         >
//                           <i className="fa-regular fa-trash-can"></i>
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//           {_Common.IsTabletMode && <MobileProductSearch />}
//           <div className="pos-footer">
//             <div className="info">
//               <h2 className="infoheader">LAST BILL INFO</h2>
//               <ul>
//                 <li>
//                   <p>Inv No :</p>
//                   <p>{_Common.LastInvNo || "-"}</p>
//                 </li>
//                 <li>
//                   <p>Paid Amt : </p>
//                   <p>
//                     {fmtINR(_Common.dLBPaidAmt)}
//                   </p>
//                 </li>
//                 <li>
//                   <p>Pay Type : </p>
//                   <p>{_Common.LasBillType || "-"}</p>
//                 </li>
//                 <li>
//                   <p>Net Amt : </p>
//                   <p>
//                     {fmtINR(_Common.dLBNetAmt)}
//                   </p>
//                 </li>
//                 <li>
//                   <p>Balance : </p>
//                   <p>
//                     {fmtINR(_Common.dLBBalAmt)}
//                   </p>
//                 </li>
//                 <li>
//                   <p>Inv Date : </p>
//                   <p>{_Common.LastInvDate || "-"}</p>
//                 </li>
//               </ul>
//             </div>
//             <div className="pos-btn-grp">
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 onClick={(e) => setisOtherCharges(true)}
//               >
//                 Other Charges
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 title="Discount (F8)"
//                 onClick={(e) => setisDiscount(true)}
//               >
//                 Discount
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 onClick={(e) => setisDelivery(true)}
//               >
//                 Delivery
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 title="Notes (F9)"
//                 onClick={(e) => setisAddNotes(true)}
//               >
//                 Notes
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={
//                   Number(_HT.iVouchId) === 0 || _HT.BtnDisable === true
//                 }
//                 onClick={(e) => {
//                   if (Number(_HT.iVouchId) === 0) {
//                     Show_Message(
//                       dispatch,
//                       "Please Select Voucher to Delete!",
//                       "info"
//                     );
//                   } else {
//                     Ask_Question(
//                       dispatch,
//                       () => runGuarded(Delete_PosInvoice),
//                       `Do You Want to Delete Invoice ?`,
//                       true
//                     );
//                   }
//                 }}
//               >
//                 Delete
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 onClick={(e) => confirmDiscardCart(() => setisReturn(true))}
//               >
//                 Return
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 title="View Invoices (F6)"
//                 onClick={(e) => setisPosView(true)}
//               >
//                 View
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="possection">
//           <div className="profile_view">
//             <h1>{_Common.strScrName}</h1>
//             <span className="profile-icon">
//               <i
//                 className="bx bx-cog"
//                 title="Menu (Ctrl+A)"
//                 onClick={(e) => Open_RightMenu()}
//               ></i>
//             </span>
//           </div>
//           <div className="card party">
//             <h2>Name : {_Customer.PartyName || "Walk-in Customer"}</h2>
//             <h2>Mobile : {_Customer.Mobile || "-"}</h2>
//             {!isConvertReturn && (
//               <span
//                 role="button"
//                 tabIndex={0}
//                 title="Select Customer (F2)"
//                 aria-label="Select Customer"
//                 onClick={(e) => dispatch(ShowHide_Popup("IsPOSCustomer"))}
//                 onKeyDown={(e) => {
//                   if (e.key === "Enter" || e.key === " ") {
//                     e.preventDefault();
//                     dispatch(ShowHide_Popup("IsPOSCustomer"));
//                   }
//                 }}
//               >
//                 <i className="fa-solid fa-user-plus"></i>
//               </span>
//             )}
//           </div>
//           <div className="card staff">
//             <h2>Billing Staff</h2>
//             <div className="st">
//               <i
//                 className="fa-solid fa-user-tie"
//                 title="Select Billing Staff"
//                 onClick={(e) => dispatch(ShowHide_Popup("IsEmployee"))}
//               ></i>
//               <sub>+</sub>
//             </div>
//             <div className="text">
//               <label>
//                 {_Employee.strEmployeeName || "Not selected"} <br />
//                 <span>{_Employee.strEmpRole}</span>
//               </label>
//               <label>Reward Point : {_Employee.dRewardPoint}</label>
//             </div>
//           </div>
//           <div className="card sum">
//             <h2>Summary</h2>
//             <div className="text">
//               <p>Sub Total</p>
//               <p>
//                 {fmtINR(Number(_Sum.GoodsValue))}
//               </p>
//             </div>
//             <div className="text">
//               <p>GST</p>
//               <p>
//                 {fmtINR(Number(_Sum.Tax))}
//               </p>
//             </div>
//             <div className="text">
//               <p>Discount</p>
//               <p>
//                 {fmtINR(Number(_Sum.Discount))}
//               </p>
//             </div>
//             {(_Disc.strCouponCode || "").length > 0 && (
//               <div className="text">
//                 <p
//                   style={{
//                     width: "100%",
//                     color: "green",
//                     fontSize: "12px",
//                     textAlign: "right",
//                   }}
//                 >
//                   {/* ✅ FIX: was `{Per + Amt}% Coupon Discount Applied` — Per and
//                       Amt are mutually exclusive (only one is ever non-zero, same
//                       pattern as item-level discount), so adding them and always
//                       labeling it "%" showed e.g. "50% Coupon Discount Applied"
//                       for a plain ₹50 amount-based coupon. */}
//                   {_Disc.dCouponDiscPer > 0
//                     ? `${_Disc.dCouponDiscPer}%`
//                     : fmtINR(Number(_Disc.dCouponDiscAmt))}{" "}
//                   Coupon Discount Applied
//                 </p>
//               </div>
//             )}
//             <div className="text">
//               <p>Other Charges</p>
//               <p>
//                 {fmtINR(Number(_Sum.AddLess))}
//               </p>
//             </div>
//             <div className="text">
//               <p>Round Off</p>
//               <p>
//                 {fmtINR(Number(_Sum.RoundOff))}
//               </p>
//             </div>
//             <div className="text">
//               <p>
//                 TOTAL
//                 <br />
//                 <span>
//                   (Item : {_DT.arrEntDT.length},Qty : {_Sum.Qty})
//                 </span>
//               </p>
//               <p>
//                 {fmtINR(Number(_Sum.NetAmt))}
//               </p>
//             </div>
//           </div>
//           <div className="card">
//             <h2>Payment</h2>
//             <div className="Payment" id="btn-paymt">
//               {PAY_MODES.map((id, i) => (
//                 <button
//                   key={id}
//                   type="button"
//                   ref={(el) => (payRefs.current[i] = el)}
//                   className={
//                     Number(_HT.iBillTypeId) === id ? "icon active" : "icon"
//                   }
//                   title={`${PAY_LABELS[id]} (F4)`}
//                   aria-label={PAY_LABELS[id]}
//                   aria-pressed={Number(_HT.iBillTypeId) === id}
//                   onClick={(e) => Update_PaymentMode(id)}
//                   onKeyDown={(e) => {
//                     if (e.key === "ArrowLeft") {
//                       e.preventDefault();
//                       Next_PaymentMode(-1);
//                     }
//                     if (e.key === "ArrowRight") {
//                       e.preventDefault();
//                       Next_PaymentMode(1);
//                     }
//                   }}
//                 >
//                   {id === 8 ? <p>UPI</p> : <i className={PAY_ICONS[id]}></i>}
//                 </button>
//               ))}
//             </div>
//           </div>
//           <div className="pos-sum-btn">
//             <button
//               className="btn-fabgreen"
//               ref={buttonclear}
//               title="Clear Invoice (Ctrl+E)"
//               onClick={Clear_Click}
//             >
//               <span>
//                 <i className="fa-solid fa-eraser mr-2"></i> Clear Invoice
//               </span>
//             </button>
//             <button
//               className="btn-fabgreen"
//               ref={buttonsave}
//               disabled={_DT.arrEntDT.length > 0 ? false : true}
//               title="Save (Ctrl+S)"
//               onClick={Save_Click}
//             >
//               <span>
//                 <i className="fa-regular fa-floppy-disk mr-2"></i>
//                 {isConvertReturn ? "Save Return" : "Save Invoice"}
//               </span>
//             </button>
//           </div>
//         </div>
//         {_Common.IsRightMenu && <Posrightmenu />}
//         {_Common.IsPOSCustomer && <CustomerSearch />}
//         {_Common.IsEmployee && <StaffProfile />}
//         {_Common.IsPosPro && <PosproductInput />}
//         {_Common.IsProRemark && <ItemRemarks />}
//         {_Common.IsProCal && <RootCalculation />}
//         {_Common.IsSession && (
//           <Sessionopenclose SessionOpen={Load_PosInvoice} />
//         )}
//         {_Common.IsProSearch && (
//           <TransProductSearch Add_NewProduct={Add_NewProduct} />
//         )}
//         {_Common.IsBatchPro && (
//           <BatchProductSearch Add_NewProduct={Add_NewProduct} />
//         )}
//         {_Common.IsAttPro && (
//           <AttributeProductSearch Add_NewProduct={Add_NewProduct} />
//         )}
//         {isReceipt && (
//           <Receipt
//             Close={(e) => setisReceipt(false)}
//             PayMode={Number(_HT.iBillTypeId)}
//             NetAmt={Number(_Sum.NetAmt)}
//             Save_Invoice={(e) => runGuarded(() => Save_Invoice(false, e))}
//           />
//         )}
//         {isDelivery && (
//           <DeliveryOption Close={(e) => setisDelivery(false)} />
//         )}
//         {isPosView && (
//           <PosView
//             Close={(e) => setisPosView(false)}
//             ViewInvoice={View_posinvoice}
//             Return={(PosInvId) =>
//               confirmDiscardCart(() => {
//                 setisPosView(false);
//                 setisProReturn(true);
//                 setiVouchId(PosInvId);
//               })
//             }
//           />
//         )}

//         {isReturn && (
//           <POSReturn
//             Close={(e) => setisReturn(false)}
//             New_Return={(id) => {
//               // invoice picked in the Return popup -> choose items / qty to return
//               setisReturn(false);
//               setiVouchId(id);
//               setisProReturn(true);
//             }}
//             View_Return={() => {
//               setisReturn(false);
//               setisConvertReturn(true);
//             }}
//           />
//         )}
//         {isProReturn && (
//           <ProductReturn
//             Close={(e) => {
//               setiVouchId(0);
//               setisProReturn(false);
//             }}
//             VouchId={iVouchId}
//             View_Return={(arrperm) => {
//               setiVouchId(0);
//               setisConvertReturn(true);
//               setisProReturn(false);
//               setarrEntPermission(arrperm);
//             }}
//           />
//         )}
//         {isOtherCharges && (
//           <OtherCharges Close={(e) => setisOtherCharges(false)} />
//         )}
//         {isDiscount && <Discount Close={(e) => setisDiscount(false)} />}
//         {isAddNotes && <Notes Close={(e) => setisAddNotes(false)} />}
//         <Messagedialogbox />
//       </div>
//     </div>
//   );
// }
// export default Pointofsales;



import React, { useEffect, useRef, useState } from "react";
import PrinterSetting from "../Print/PrinterSetting";
import { useDispatch, useSelector, useStore } from "react-redux";
import $ from "jquery";
import { useLocation } from "react-router-dom";
import {
  add_BillDiscount,
  Clear_invoice,
  setothercharges,
} from "../features/POS";
import PosView from "./PosView";
import Print_DesignCaller from "../General/Print_DesignCaller";
import EmailPopup from "../General/EmailPopup";
import WhatsApp from "../General/WhatsApp";
import Notes from "./Notes";
import OtherCharges from "./OtherCharges";
import CustomerSearch from "./CustomerSearch";
import Sessionopenclose from "./Sessionopenclose";
import Receipt from "./Receipt";
import DeliveryOption from "./DeliveryOption";
import Posrightmenu from "./Posrightmenu";
import {
  Ask_Question,
  Pre_Loading,
  Show_Message,
} from "../General/Messagedialogbox";
import Messagedialogbox from "../General/Messagedialogbox";
import Discount from "./Discount";
import StaffProfile from "./StaffProfile";
import ProductReturn from "./ProductReturn";
import POSReturn from "./POSReturn";
import MobileProductSearch from "./MobileProductSearch";
import {
  API_FETCH,
  API_POST,
  API_POSTParem,
  DecryptData,
} from "../General/Utility";
import { Update_AdminCntrl } from "../features/CommonStates";
import {
  AddProduct,
  Apply_CouponDiscount,
  Apply_RewardDiscount,
  Clear_POSCustomer,
  Clear_Transaction,
  CustomerInput_Onchange,
  Load_NewSession,
  Modify_Product,
  Modify_Vouchers,
  Remove_product,
  ShowHide_Popup,
  Update_BillType,
  setPOS_DefaultParems,
} from "../features/Transactionstates";
import TransProductSearch from "../Transaction/TransProductSearch";
import BatchProductSearch from "../Transaction/BatchProductSearch";
import AttributeProductSearch from "../Transaction/AttributeProductSearch";
import { TransConfig } from "../Transaction/Transaction";
import PosproductInput from "./PosproductInput";
import ItemRemarks from "../Transaction/ItemRemarks";
import RootCalculation from "../Transaction/RootCalculation";
// A1 / A4: NaN-safe discount payloads + IST business date
import {
  Disc_HeaderParems,
  Disc_TransParems,
  fnApiDate,
  fnBusinessDate,
  fnNewRequestId,
  num,
} from "../General/Utility";

// ---------- module level helpers (no re-creation on every render) ----------
// en-IN => lakh/crore grouping (12,34,567.00). en-GB showed 1,234,567.00 for INR.
const INR = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" });
const fmtINR = (v) => INR.format(Number(v) || 0);
// dd/MM/yyyy ; empty for null / .NET default date (0001-01-01)
const fmtDate = (v) => {
  if (!v) return "";
  if (typeof v === "string" && /^\d{2}[/-]\d{2}[/-]\d{4}/.test(v)) return v;
  const d = new Date(v);
  if (isNaN(d.getTime()) || d.getFullYear() < 1900) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}`;
};
// Validity / Pay term / Delivery term are INT columns (ValidityDays ...) on the server:
// "" or undefined makes MySQL fail with "Incorrect integer value: ''". Always send a number.
const dayStr = (v) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? String(n) : "0";
};
// Cash, Card, Bank, Wallet, UPI  (same ids the screen already used)
const PAY_MODES = [2, 6, 4, 7, 8];
const PAY_LABELS = { 2: "Cash", 6: "Card", 4: "Bank", 7: "Wallet", 8: "UPI" };
const PAY_ICONS = {
  2: "fa-solid fa-indian-rupee-sign",
  6: "fa-regular fa-credit-card",
  4: "fa-solid fa-building-columns",
  7: "fa-solid fa-wallet",
};

function Pointofsales() {
  const dispatch = useDispatch();
  const store = useStore();
  const location = useLocation();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const tableRef = useRef(null);
  const buttonsave = useRef();
  const buttoncard = useRef();
  const buttonclear = useRef();
  const rowRefs = useRef([]); // item table rows (keyboard navigation)
  const payRefs = useRef([]); // payment mode buttons
  const keyHandlerRef = useRef(null); // always points to latest key handler (no stale state)
  const isBusyRef = useRef(false); // blocks double submit / double click
  // One idempotency key per bill: every retry of the SAME bill (double click,
  // Enter + click, timeout after the server already committed) carries the same
  // key, so the server answers from its replay cache instead of saving twice.
  // A new key is issued only when the screen moves to a different bill.
  const saveRequestIdRef = useRef(fnNewRequestId());
  const Renew_SaveRequestId = () => {
    saveRequestIdRef.current = fnNewRequestId();
  };
  const itemMutationQueueRef = useRef(Promise.resolve());
  const pendingItemMutationRef = useRef(0);
  const itemMutationContextRef = useRef(0);
  const productViewRequestRef = useRef(0);
  const enqueueItemMutation = (fn) => {
    pendingItemMutationRef.current += 1;
    const task = itemMutationQueueRef.current.catch(() => {}).then(fn);
    const completed = task.finally(() => {
      pendingItemMutationRef.current = Math.max(
        0,
        pendingItemMutationRef.current - 1
      );
    });
    itemMutationQueueRef.current = completed.catch(() => {});
    return completed;
  };

  //#region  Redonly Parem from Global Redux Storage
  const _Common = useSelector((store) => store.Transstates.Common);
  const _HT = useSelector((store) => store.Transstates.Header);
  const _DT = useSelector((state) => state.Transstates.Data);
  const _Sum = useSelector((state) => state.Transstates.Summary);
  const _Employee = useSelector((state) => state.Transstates.Employee);
  const _Product = useSelector((state) => state.Transstates.Product);
  const _Pos = useSelector((state) => state.Pointofsales.Pos);
  const _Customer = useSelector((state) => state.Transstates.Customer);
  // A1: single source of truth for every discount (popup, coupon, reward,
  // modify bill). Was the legacy Pointofsales.BillDiscount slice, so the bill
  // discount / coupon / reward were sent as 0 or stale on Save and on every
  // Add / Remove item.
  const _Disc = useSelector((state) => state.Transstates.Discount);
  //#endregion

  //#region Default parems
  const [strSearch, setstrSearch] = useState("");
  const [isDiscount, setisDiscount] = useState(false);
  const [iVouchId, setiVouchId] = useState(0);
  const [isConvertReturn, setisConvertReturn] = useState(false);
  const [arrEntPermission, setarrEntPermission] = useState([]);
  //#endregion

  //#region Popup Parems
  const [isPosView, setisPosView] = useState(false);
  const [isAddNotes, setisAddNotes] = useState(false);
  const [isOtherCharges, setisOtherCharges] = useState(false);
  const [isReceipt, setisReceipt] = useState(false);
  const [isAddtoCart, setisAddtoCart] = useState(false);
  const [isDelivery, setisDelivery] = useState(false);
  const [isReturn, setisReturn] = useState(false);
  const [isSaving, setisSaving] = useState(false); // disables Save while a server action runs
  const [isProReturn, setisProReturn] = useState(false);
  const [posShareRequest, setposShareRequest] = useState(null);
  //#endregion
  const _ScrId = 93;

  const Print_POSVoucher = async (VouchId, ScrId, PrintFor) => {
    const iVouchId = Number(VouchId);
    if (!Number.isSafeInteger(iVouchId) || iVouchId <= 0) {
      Show_Message(dispatch, "Please select a voucher", "info");
      return;
    }
    let printWindow = null;
    if (PrintFor === "Print") {
      printWindow = window.open("about:blank", "_blank");
      if (!printWindow) {
        Show_Message(dispatch, "Allow pop-ups to print this voucher", "info");
        return;
      }
      printWindow.opener = null;
    }
    try {
      await Pre_Loading(dispatch, true);
      const objPrint = await Print_DesignCaller(
        _AuthParems,
        Number(ScrId),
        "Transaction",
        iVouchId,
        0,
        PrintFor,
        dispatch,
        true
      );
      if (!objPrint || !objPrint.PdfURL) {
        if (printWindow && !printWindow.closed) printWindow.close();
        return;
      }
      const response = await fetch(objPrint.PdfURL);
      if (!response.ok) throw new Error("Unable to prepare the voucher PDF");
      const pdfBlob = await response.blob();
      if (!pdfBlob.size) throw new Error("The voucher PDF is empty");
      const blobUrl = URL.createObjectURL(pdfBlob);
      if (printWindow && !printWindow.closed) {
        printWindow.location.replace(blobUrl);
      } else {
        const link = document.createElement("a");
        const fileName = String(objPrint.FileName || "Invoice")
          .replace(/\.pdf$/i, "")
          .replace(/[\\/:*?\"<>|]/g, "_");
        link.href = blobUrl;
        link.download = `${fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
      window.setTimeout(() => URL.revokeObjectURL(blobUrl), 300000);
    } catch (err) {
      if (printWindow && !printWindow.closed) printWindow.close();
      Show_Message(dispatch, err?.message || "Voucher printing failed", "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  const Open_POSShare = (VouchId, ScrId, Type) => {
    const iVouchId = Number(VouchId);
    if (!Number.isSafeInteger(iVouchId) || iVouchId <= 0) {
      Show_Message(dispatch, "Please select a voucher", "info");
      return;
    }
    setisPosView(false);
    setisReturn(false);
    setposShareRequest({ iVouchId, iScrId: Number(ScrId), Type });
  };

  const hasUnsavedCart =
    (_DT.arrEntDT.length > 0 || pendingItemMutationRef.current > 0) &&
    !isAddtoCart;

  useEffect(() => {
    Load_PosInvoice().then((session) => {
      // opened from the "Return" menu (/Pointofsales/POSReturn): show the return
      // list once the session/admin params are loaded (needs a running session)
      if (session > 0 && /\/posreturn\/?$/i.test(location.pathname)) {
        setisReturn(true);
      }
    });
    // ✅ FIX: listener registered once but it always calls the LATEST handler
    // (before, it captured the first render's state forever -> stale isAddtoCart etc.)
    const onKey = (e) => {
      if (keyHandlerRef.current) keyHandlerRef.current(e);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // Warn before tab close / refresh when the cashier has an unsaved bill
  useEffect(() => {
    if (!hasUnsavedCart) return;
    const warn = (e) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", warn);
    return () => window.removeEventListener("beforeunload", warn);
  }, [hasUnsavedCart]);

  // New bill should always start with a selected payment mode (Cash)
  useEffect(() => {
    if (
      !PAY_MODES.includes(Number(_HT.iBillTypeId)) &&
      !isAddtoCart &&
      !isConvertReturn
    ) {
      dispatch(Update_BillType(2));
    }
  }, [_HT.iBillTypeId, isAddtoCart, isConvertReturn]);
  const Load_PosInvoice = async () => {
    let sessionId = 0;
    try {
      await Pre_Loading(dispatch, true);
      const _LocalParems = await DecryptData(localStorage.jbctrlparams);
      sessionId = Number(_LocalParems.Session) || 0;
      await dispatch(Update_AdminCntrl(_LocalParems));
      if (Number(_LocalParems.Session) === 0) {
        const res = await API_FETCH(
          `POS/Load_Employee/${Number(_LocalParems.Branch)}/${_LocalParems.DB}`,
          dispatch
        );
        if (res) {
          res.Counter = Number(_LocalParems.Counter);
          await dispatch(Load_NewSession(res));
          await dispatch(ShowHide_Popup({ isshow: "IsSession", default: true }));
        }
      } else {
        const config = TransConfig(_ScrId);
        const objTrans = await {
          strController: config.Controller,
          strScrType: config.strScrType,
          iScrId: config.iScrId,
          strScrName: config.strScrName,
          iPartyScrId: 2,
          iPartyId: 0,
          iVenType: 0,
          strSearch: "",
          strColName: "",
          strDBName: _LocalParems.DB,
          iClientId: Number(_LocalParems.Client),
          iUserId: Number(_LocalParems.User),
          iRoleId: Number(_LocalParems.Role),
          iBranchId: Number(_LocalParems.Branch),
          iCounterId: Number(_LocalParems.Counter),
          iSessionId: Number(_LocalParems.Session),
        };
        const res = await API_POST(`POS/Load_Invoice/`, objTrans, dispatch);
        if (res) {
          res.Transparem = objTrans;
          await dispatch(setPOS_DefaultParems(res));
        }
      }
    } catch (err) {
      Show_Message(dispatch, err.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
    return sessionId;
  };

  //#region  Click Event
  const Save_Invoice = async (isHoldInvoice, ObjReceipt) => {
    // A4: a NEW bill is dated "today in IST" at the moment it is saved (the
    // header date may be from page-load time, e.g. a tab left open past
    // midnight). A modified bill keeps its original date.
    const strBillDate =
      Number(_HT.iVouchId) > 0 && _HT.strVouchDate
        ? fnApiDate(_HT.strVouchDate)
        : fnBusinessDate();
    let ReceiptDt = {};
    let URL = "POS/InsUpd_Invoice/";
    if (isHoldInvoice === false) {
      ReceiptDt = {
        strPrefix: "",
        iNumSeqNo: 0,
        strCompCode: "",
        strFinanFrom: "",
        strRecNo: "",
        strTransNo: "",
        dpRecDate: strBillDate,
        iVenType: 5,
        iVenId: num(_Customer.PartyId) || num(_HT.iPartyId),
        iPayModeId: _HT.iBillTypeId,
        dAmount: num(ObjReceipt.dAmount),
        iVouchId: 0,
        iBankAccId: ObjReceipt.iBankAccId,
        strChequeNo: ObjReceipt.strChequeNo,
        dpChequeDate: fnApiDate(ObjReceipt.strChequeDate, strBillDate),
        strAccNo: ObjReceipt.strAccNo,
        strAccHolderName: ObjReceipt.strAccHolderName,
        strPrintName: ObjReceipt.strPrintName,
        strRemark: ObjReceipt.strRemark,
        iBNId: ObjReceipt.iBankId,
        iRecId: 0,
        iCallerScrId: 93,
        strBankName: "",
        strFilter: "",
        strFilterColumn: "",
        strSearch: "",
        strVenName: "",
        strDBName: _AuthParems.DB,
        iSessionId: Number(_AuthParems.Session),
      };
    } else {
      URL = "POS/InsUpd_Cart/"; // Hold Invoice
      ReceiptDt = {
        strPrefix: "",
        iNumSeqNo: 0,
        strCompCode: "",
        strFinanFrom: "",
        strRecNo: "",
        strTransNo: "",
        dpRecDate: strBillDate,
        iVenType: 5,
        iVenId: 0,
        iPayModeId: 0,
        dAmount: 0,
        iVouchId: 0,
        iBankAccId: 0,
        strChequeNo: "",
        dpChequeDate: strBillDate,
        strAccNo: "",
        strAccHolderName: "",
        strPrintName: "",
        strRemark: "",
        iBNId: 0,
        iRecId: 0,
        iCallerScrId: 0,
        strBankName: "",
        strFilter: "",
        strFilterColumn: "",
        strSearch: "",
        strVenName: "",
        strDBName: "",
        iSessionId: 0,
      };
    }
    const POSInvListHT = {
      iPosInvId: _HT.iVouchId,
      iTitleTag: _Common.iScrId,
      // customer picked in the popup wins; else the bill's own party (modify bill)
      iPartyId: num(_Customer.PartyId) || num(_HT.iPartyId),
      strShippingAdd: _HT.strShippingAdd,
      iNumSeqNo: 0,
      strPrefix: "",
      strCompCode: "",
      strFinanFrom: "",
      strTransNo: "",
      strVouchNo: _HT.strVouchNo,
      strVouchDate: strBillDate,
      // A1: the AL bill-discount id comes from the POS config (was always 0)
      iAddLessBillDiscId:
        num(_Common.iALBillDiscId) || num(_Disc.iALBillDiscId),
      iBillTypeId: _HT.iBillTypeId,
      iTaxCalcOnId: num(_Common.iTaxCalcOnId),
      iTaxTypeId: num(_HT.iTaxRelId),
      iDMId: _HT.iDMId,
      strConvertDCVouch: _HT.strConvertDCVouch,
      strPartyDCVouch: _HT.strPartyDCVouch,
      strRefNum1: _HT.strRefNum1,
      dpRefNum1Date: fnApiDate(_HT.dpRefNum1Date),
      strRefNum2: _HT.strRefNum2,
      dpRefNum2Date: fnApiDate(_HT.dpRefNum2Date),
      strRefNum3: _HT.strRefNum3,
      dpRefNum3Date: fnApiDate(_HT.dpRefNum3Date),
      strRefNum4: _HT.strRefNum4,
      dpRefNum4Date: fnApiDate(_HT.dpRefNum4Date),
      strRemark1: _HT.strRemark1,
      strRemark2: _HT.strRemark2,
      strRemark3: _HT.strRemark3,
      strRemark4: _HT.strRemark4,
      strValidity: dayStr(_HT.strValidity ?? _HT.iValidity),
      dpValDateUpto: fnApiDate(_HT.dpValDateUpto),
      strPayTerm: dayStr(_HT.strPayTerm ?? _HT.iPayTerm),
      dpPayTermDateUpto: fnApiDate(_HT.dpPayTermDateUpto),
      strDeliTerm: dayStr(_HT.strDeliTerm ?? _HT.iDeliTerm),
      dpDelTermDateUpto: fnApiDate(_HT.dpDelTermDateUpto),

      strEComGstNo: _HT.strEComGstNo,
      strTransport: _HT.strTransport,
      strVehicle: _HT.strVehicle,
      strDespatch: _HT.strDespatch,
      dpDespatchDate: fnApiDate(_HT.dpDespatchDate),
      strLRNNumber: _HT.strLRNNumber,
      dpLRNoDate: fnApiDate(_HT.dpLRNoDate),
      strAgent: _HT.strAgent,
      strReference: _HT.strReference,
      strDestination: _HT.strDestination,

      // A1: dTBill*, dTAddLess*, dRoyaltyPoint and iCouponId all come from
      // state.Transstates.Discount (NaN-safe)
      ...Disc_HeaderParems(_Disc),

      dTotQty: num(_Sum.Qty),
      dTotGoodval: num(_Sum.GoodsValue),
      dTotDiscount: num(_Sum.Discount),
      dTotTax: num(_Sum.Tax),
      dAddLess: num(_Sum.AddLess),
      dTotTCSTax: num(_Sum.TCSTax),
      dRoundOff: num(_Sum.RoundOff),
      dNetAmt: num(_Sum.NetAmt),
      iCartInvId: num(_HT.iCartInvId),
      iUserId: Number(_AuthParems.User),
      iEmpId: num(_Employee.iEmpId),
      FYid: Number(_AuthParems.Year),
      strDBName: _AuthParems.DB,
      iSessionId: Number(_AuthParems.Session),
      iBranchId: Number(_AuthParems.Branch),
    };
    const objCust = {
      PartyId: _Customer.PartyId,
      PartyName: _Customer.PartyName,
      PartyCode: _Customer.PartyCode,
      AliasName: _Customer.AliasName,
      Address1: _Customer.Address1,
      Address2: _Customer.Address2,
      Address3: _Customer.Address3,
      Address4: _Customer.Address4,
      State: _Customer.State,
      Country: _Customer.Country,
      Pincode: _Customer.Pincode,
      Mobile: _Customer.Mobile,
      Phone: _Customer.Phone,
      Email: _Customer.Email,
      GST: _Customer.GST,
      Remark: _Customer.Remark,
      RoyaltyPoint: _Customer.RoyaltyPoint,
      ShippAdd: _Customer.ShippAdd,
      IsSameAdd: _Customer.IsSameAdd,
      Status: _Customer.Status,
      CreatedBy: _Customer.CreatedBy,
      RewardType: _Customer.RewardType,
      // ✅ FIX: the API model is PosCustomerMasterModel (iCustId, strCustName,
      // strAdd1-4, strPincode, iCountry, iState, strMobile1/2, strEmail,
      // dRoyaltyPoint). None of the keys above exist on it, so the customer
      // typed / selected in the popup was silently dropped by the JSON binder.
      iCustId: num(_Customer.PartyId),
      strCustName: _Customer.PartyName,
      strAdd1: _Customer.Address1,
      strAdd2: _Customer.Address2,
      strAdd3: _Customer.Address3,
      strAdd4: _Customer.Address4,
      strPincode: _Customer.Pincode,
      iCountry: num(_Customer.CountryId),
      iState: num(_Customer.StateId),
      strMobile1: _Customer.Mobile,
      strMobile2: _Customer.Phone,
      strEmail: _Customer.Email,
      dRoyaltyPoint: num(_Customer.RoyaltyPoint),
    };
    if (isHoldInvoice === false)
      URL =
        "POS/InsUpd_Invoice/?reqId=" +
        encodeURIComponent(saveRequestIdRef.current);
    const res = await API_POST(
      URL,
      {
        objEntPos: POSInvListHT,
        objTransDT: _DT.arrEntDT,
        objDTHelp: _DT.arrEntDTHelp,
        objEntALDT: _DT.arrEntAL,
        objEntTax: _DT.arrEntTax,
        objEntCust: objCust,
        objEntReceipt: ReceiptDt,
      },
      dispatch
    );
    if (res) {
      Show_Message(dispatch, res.strMessage, "success");
      await CancelInvoice();
    }
  };
  const InsUpd_Return = async () => {
    const ReturnHT = {
      iPOSRetId: _HT.iVouchId,
      iTitleTag: 96,
      // customer picked in the popup wins; else the bill's own party (modify bill)
      iPartyId: Number(_Customer.PartyId) || Number(_HT.iPartyId) || 0,
      strShippingAdd: _HT.strShippingAdd,
      strVouchNo: _HT.strVouchNo,
      // A4: a new return is dated today (IST); a modified one keeps its date
      strVouchDate:
        Number(_HT.iVouchId) > 0 && _HT.strVouchDate
          ? fnApiDate(_HT.strVouchDate)
          : fnBusinessDate(),
      // A1: the AL bill-discount id comes from the POS config (was always 0)
      iAddLessBillDiscId:
        num(_Common.iALBillDiscId) || num(_Disc.iALBillDiscId),
      iBillTypeId: _HT.iBillTypeId,
      iTaxCalcOnId: num(_Common.iTaxCalcOnId),
      iTaxTypeId: Number(_HT.iTaxRelId),
      iDMId: _HT.iDMId,
      strConvertDCVouch: _HT.strConvertDCVouch,
      strPartyDCVouch: _HT.strPartyDCVouch,
      strRefNum1: _HT.strRefNum1,
      dpRefNum1Date: fnApiDate(_HT.dpRefNum1Date),
      strRefNum2: _HT.strRefNum2,
      dpRefNum2Date: fnApiDate(_HT.dpRefNum2Date),
      strRefNum3: _HT.strRefNum3,
      dpRefNum3Date: fnApiDate(_HT.dpRefNum3Date),
      strRefNum4: _HT.strRefNum4,
      dpRefNum4Date: fnApiDate(_HT.dpRefNum4Date),
      strRemark1: _HT.strRemark1,
      strRemark2: _HT.strRemark2,
      strRemark3: _HT.strRemark3,
      strRemark4: _HT.strRemark4,
      strValidity: dayStr(_HT.strValidity ?? _HT.iValidity),
      dpValDateUpto: fnApiDate(_HT.dpValDateUpto),
      strPayTerm: dayStr(_HT.strPayTerm ?? _HT.iPayTerm),
      dpPayTermDateUpto: fnApiDate(_HT.dpPayTermDateUpto),
      strDeliTerm: dayStr(_HT.strDeliTerm ?? _HT.iDeliTerm),
      dpDelTermDateUpto: fnApiDate(_HT.dpDelTermDateUpto),

      strEComGstNo: _HT.strEComGstNo,
      strTransport: _HT.strTransport,
      strVehicle: _HT.strVehicle,
      strDespatch: _HT.strDespatch,
      dpDespatchDate: fnApiDate(_HT.dpDespatchDate),
      strLRNNumber: _HT.strLRNNumber,
      dpLRNoDate: fnApiDate(_HT.dpLRNoDate),
      strAgent: _HT.strAgent,
      strReference: _HT.strReference,
      strDestination: _HT.strDestination,

      // A1: dTBill*, dTAddLess*, dRoyaltyPoint and iCouponId from
      // state.Transstates.Discount (NaN-safe)
      ...Disc_HeaderParems(_Disc),

      dTotQty: Number(_Sum.Qty),
      dTotGoodval: Number(_Sum.GoodsValue),
      dTotDiscount: Number(_Sum.Discount),
      dTotTax: Number(_Sum.Tax),
      dAddLess: Number(_Sum.AddLess),
      dTotTCSTax: Number(_Sum.TCSTax),
      dRoundOff: Number(_Sum.RoundOff),
      dNetAmt: Number(_Sum.NetAmt),
      iCartInvId: _HT.iCartInvId,
      iUserId: Number(_AuthParems.User),
      iEmpId: Number(_Employee.iEmpId),
      FYid: Number(_AuthParems.Year),
      strDBName: _AuthParems.DB,
      iSessionId: Number(_AuthParems.Session),
      iBranchId: Number(_AuthParems.Branch),
    };
    const res = await API_POST(
      "POS/InsUpd_Return?reqId=" + encodeURIComponent(saveRequestIdRef.current),
      {
        objEntPos: ReturnHT,
        objBaseTransDT: _DT.arrEntDT,
        objDTHelp: _DT.arrEntDTHelp,
        objEntALDT: _DT.arrEntAL,
        objEntTax: _DT.arrEntTax,
      },
      dispatch
    );
    if (res) {
      Show_Message(dispatch, res.strMessage, "success");
      await CancelInvoice();
    }
  };
  const Delete_PosInvoice = async () => {
    const res = await API_POSTParem(
      `POS/Delete_Invoice/${Number(_HT.iVouchId)}/${Number(
        _AuthParems.Branch
      )}/${_AuthParems.DB}`,
      dispatch
    );
    if (res) {
      Show_Message(dispatch, res.strMessage, "success");
      await CancelInvoice();
    }
  };
  const Delete_Return = async () => {
    const res = await API_POSTParem(
      `POS/Delete_Return/${Number(_HT.iVouchId)}/${Number(
        _AuthParems.Branch
      )}/${_AuthParems.DB}`,
      dispatch
    );
    if (res) {
      Show_Message(dispatch, res.strMessage, "success");
      await CancelInvoice();
    }
  };
  // A1/A2: clear the cart context WITHOUT reloading the session (safe now that
  // Clear_Transaction keeps the session). Used before a return starts, so the
  // current bill's discounts / other charges can never leak into a return.
  const Reset_CartContext = () => {
    Renew_SaveRequestId();
    setisAddtoCart(false);
    setisConvertReturn(false);
    dispatch(Clear_invoice());
    dispatch(Clear_Transaction());
    dispatch(Clear_POSCustomer());
  };
  const CancelInvoice = async () => {
    Renew_SaveRequestId(); // next bill => next idempotency key
    itemMutationContextRef.current += 1;
    productViewRequestRef.current += 1;
    setisAddtoCart(false);
    setisConvertReturn(false);
    setisReceipt(false);
    dispatch(Clear_invoice()); // legacy slice (BillDiscount / Pos)
    // ✅ FIX: cart, header, summary and customer live in Transstates; only the
    // legacy slice was cleared, so after Save / Clear the old bill stayed on screen.
    dispatch(Clear_Transaction());
    dispatch(Clear_POSCustomer());
    await Load_PosInvoice();
  };
  // Runs one server action at a time: loader on/off, errors shown, no double submit.
  // isBusyRef is the synchronous lock (a second click in the same tick is
  // dropped before React re-renders); isSaving only drives the button state.
  const runGuarded = async (fn) => {
    if (isBusyRef.current) return;
    isBusyRef.current = true;
    setisSaving(true);
    try {
      await Pre_Loading(dispatch, true);
      await fn();
    } catch (err) {
      Show_Message(
        dispatch,
        (err && err.message) || "Unexpected error. Please try again.",
        "error"
      );
    } finally {
      await Pre_Loading(dispatch, false);
      isBusyRef.current = false;
      setisSaving(false);
    }
  };
  // Ask before throwing away an unsaved cart
  const confirmDiscardCart = (next, msg) => {
    if (
      (_DT.arrEntDT.length > 0 || pendingItemMutationRef.current > 0) &&
      !isAddtoCart &&
      !isConvertReturn
    ) {
      Ask_Question(
        dispatch,
        next,
        msg || "Current invoice has unsaved items. Do you want to discard them?",
        true
      );
    } else {
      next();
    }
  };
  const Clear_Click = () => {
    if (
      (_DT.arrEntDT.length > 0 || pendingItemMutationRef.current > 0) &&
      !isAddtoCart
    ) {
      Ask_Question(
        dispatch,
        CancelInvoice,
        "Clear the current invoice? All items will be removed.",
        true
      );
    } else {
      CancelInvoice();
    }
  };
  const Show_Receipt = () => {
    setisReceipt(true);
  };
  const Save_Click = () => {
    if (isBusyRef.current) return; // a save / load is already running
    if (pendingItemMutationRef.current > 0) {
      Show_Message(
        dispatch,
        "Please wait for item calculation to finish",
        "info"
      );
    } else if (_DT.arrEntDT.length === 0) {
      Show_Message(dispatch, "At least one item is required", "info");
    } else if (Number(_AuthParems.Session) === 0) {
      Show_Message(dispatch, "Please start a session before billing", "info");
      if (!_Common.IsSession) dispatch(ShowHide_Popup("IsSession"));
    } else if (isConvertReturn) {
      // ✅ FIX: "Save Return" used to open the receipt and post to the SALES
      // invoice endpoint. InsUpd_Return existed but was never called.
      Ask_Question(
        dispatch,
        () => runGuarded(InsUpd_Return),
        `Do You Want to Save "Return"?`
      );
    } else if (Number(_Sum.NetAmt) < 0) {
      Show_Message(dispatch, "Net amount cannot be negative", "info");
    } else if (Number(_HT.iBillTypeId) === 0) {
      Show_Message(dispatch, "Bill Type is Required", "info");
    } else {
      Ask_Question(dispatch, Show_Receipt, `Do You Want to Save "Invoice"?`);
    }
  };
  //#endregion

  //#region  View Methods
  const View_posinvoice = (vouchid) =>
    confirmDiscardCart(
      () => runGuarded(() => Load_SelectedInvoice(vouchid)),
      "Current invoice has unsaved items. Discard them and open the selected invoice?"
    );
  const Load_SelectedInvoice = async (vouchid) => {
    Renew_SaveRequestId(); // modifying another bill => its own idempotency key
    itemMutationContextRef.current += 1;
    productViewRequestRef.current += 1;
    const res = await API_FETCH(
      `POS/View_VoucherDetails/${vouchid}/93/${Number(_AuthParems.Branch)}/${
        _AuthParems.DB
      }`,
      dispatch
    );
    // error / empty => stay where we are (API_FETCH already showed the message)
    if (!res || !Array.isArray(res.objEntHT) || res.objEntHT.length === 0)
      return;

    const _EntHT = res.objEntHT[0];
    const PartyList = res.objPartyList || [];
    setisPosView(false);
    // Add To Cart Not Allowed When Modify Bill
    setisAddtoCart(true);
    // ✅ FIX: the screen reads Transstates (Header / Data / Summary / Customer).
    // Modify_Vouchers also loads Transstates.Discount (bill + AL discount) for scr 93.
    dispatch(
      Modify_Vouchers({
        VouchId: _EntHT.iPosInvId,
        Data: {
          EntHT: [
            {
              ..._EntHT,
              strPartyName: PartyList[0],
              billAdd: PartyList[1],
              shippAdd: _EntHT.strShippingAdd,
              isAccess:
                _EntHT.bCancelStatus !== true && res.objCanAccess !== false,
            },
          ],
          EntDT: res.objEntDT || [],
          EntTax: res.objEntTax || [],
          EntPenCon: [],
          EntAL: res.objEntALDT || [],
          EntDTHelp: res.objEntDTHelp || [],
          Summary: res.objEntSummary || {},
        },
      })
    );
    // A1: coupon / reward come from THIS bill, never from the previous cart
    dispatch(
      Apply_CouponDiscount({
        iCouponId: num(_EntHT.iCouponId),
        strCouponCode: _EntHT.strCouponCode || "",
        dCouponDiscPer: num(_EntHT.dCouponDiscPer),
        dCouponDiscAmt: num(_EntHT.dCouponDiscAmt),
      })
    );
    dispatch(
      Apply_RewardDiscount({
        dRewardPointper: 0,
        dRewardPointAmt: num(_EntHT.dRoyaltyPoint),
      })
    );
    [
      ["PartyId", _EntHT.iPartyId],
      ["PartyName", PartyList[0]],
      ["Mobile", PartyList[2]],
      ["GST", PartyList[3]],
      ["ShippAdd", _EntHT.strShippingAdd],
      ["RoyaltyPoint", num(_EntHT.dRoyaltyPoint)],
    ].forEach(([Name, Value]) =>
      dispatch(CustomerInput_Onchange({ Name, Value }))
    );
    // legacy mirror (the fixed reducer now keeps the AL fields + id)
    dispatch(
      add_BillDiscount({
        dBillDisPer: _EntHT.dTBillDiscPer,
        dBillDisAmt: _EntHT.dTBillDiscAmt,
        dBillDisValue: _EntHT.dTBillDiscValue,
        dALBillDisPer: _EntHT.dTAddLessDiscPer,
        dALBillDisAmt: _EntHT.dTAddLessDiscAmt,
        dALBillDisValue: _EntHT.dTAddLessDiscValue,
        iALBillDiscId: _EntHT.iAddLessBillDiscId,
      })
    );
    dispatch(
      setothercharges({
        SerId: 0,
        ServiceName: "",
        SerCode: "",
        SACcode: "",
        bUpdateStatus: false,
        iRowIndex: 0,
        RateWithoutTax: (0).toFixed(2),
        RateWithTax: (0).toFixed(2),
        dTaxPer: 0,
        EntALTax: (res.EntService && res.EntService._EntServiceTax) || [],
      })
    );
  };
  //#endregion

  //#region Common Methods

  // ✅ FIX: was jQuery toggleClass("active") -> clicking the selected mode again
  // un-highlighted everything, F4 never cycled, and "Clear Invoice" left the old
  // highlight while redux had been reset. Highlight now comes from redux state.
  const Update_PaymentMode = (PayId) => {
    dispatch(Update_BillType(PayId));
    const idx = PAY_MODES.indexOf(PayId);
    if (payRefs.current[idx]) payRefs.current[idx].focus();
  };
  const Next_PaymentMode = (step) => {
    const cur = PAY_MODES.indexOf(Number(_HT.iBillTypeId));
    const next = (cur + step + PAY_MODES.length) % PAY_MODES.length;
    Update_PaymentMode(PAY_MODES[next]);
  };
  const validatename = (columnName) => {
    switch (columnName) {
      case "proName":
      case "unitName":
      case "attValues":
      case "taxPer":
        return false;
      default:
        return true;
    }
  };
  const validatedatatype = (columnName, DataType) => {
    switch (columnName) {
      case "manufactureDate":
      case "expiryDate":
        return "Date";
      default:
        if (DataType === "Decimal") return "number";
        else return "text";
    }
  };
  const converttodecimal = (type, value, len) => {
    switch (type) {
      case "Decimal":
        return Number(value).toFixed(len);
      case "Int32":
        return Number(value);
      default:
        return value;
    }
  };
  const numtodecimal = (num) => {
    return Number(num).toFixed(2);
  };
  const isTypingTarget = (el) =>
    !!el &&
    (el.tagName === "INPUT" ||
      el.tagName === "TEXTAREA" ||
      el.tagName === "SELECT" ||
      el.isContentEditable);
  const anyPopupOpen = () =>
    isPosView || isAddNotes || isOtherCharges || isReceipt || isDelivery ||
    isReturn || isProReturn || isDiscount || _Common.IsPOSCustomer ||
    _Common.IsEmployee || _Common.IsPosPro || _Common.IsProRemark ||
    _Common.IsProCal || _Common.IsSession || _Common.IsProSearch ||
    _Common.IsBatchPro || _Common.IsPrintSett ||_Common.IsAttPro ;
  const focusRow = (i) => {
    const el = rowRefs.current[i];
    if (el) el.focus();
  };
  const Open_RightMenu = () => {
    if (!_Common.IsRightMenu) dispatch(ShowHide_Popup("IsRightMenu"));
    setTimeout(() => $("#pos-menu").addClass("active"), 0);
  };
  const Open_ProductSearch = () => {
    if (Number(_AuthParems.Session) === 0) {
      Show_Message(dispatch, "Please start a session before billing", "info");
      if (!_Common.IsSession) dispatch(ShowHide_Popup("IsSession"));
      return;
    }
    if (!_Common.IsProSearch) dispatch(ShowHide_Popup("IsProSearch"));
  };
  const short_cut_keypress = (e) => {
    if (e.repeat) return; // holding a key used to toggle popups open/close/open...
    const key = (e.key || "").toLowerCase();
    const ctrl = e.ctrlKey || e.metaKey;
    const popupOpen = anyPopupOpen();

    // Ctrl+S must never reach the browser "Save page" dialog
    if (ctrl && key === "s") {
      e.preventDefault();
      if (!popupOpen && buttonsave.current && !buttonsave.current.disabled) {
        buttonsave.current.click();
      }
      return;
    }
    if (popupOpen) return; // no shortcuts underneath an open popup

    if (ctrl && e.shiftKey) {
      // ✅ FIX: ANY Ctrl+Shift combo (even Ctrl+Shift+Tab / DevTools keys)
      // used to reload the page and wipe the bill. Now only Ctrl+Shift+R.
      if (key === "r") {
        e.preventDefault();
        window.location.reload();
      }
      return;
    }
    if (ctrl) {
      if (key === "h" && buttoncard.current && !isAddtoCart) {
        // Hold invoice (only if a Hold button is actually rendered)
        e.preventDefault();
        buttoncard.current.click();
      } else if (key === "e") {
        e.preventDefault();
        if (buttonclear.current) buttonclear.current.click();
      } else if (key === "a" && !isTypingTarget(e.target)) {
        // keep Ctrl+A = "select all" while typing in a text box
        e.preventDefault();
        Open_RightMenu();
      }
      return;
    }
    switch (e.key) {
      case "F1": {
        e.preventDefault();
        const box = document.getElementById("pro-search");
        if (box) {
          box.focus();
          box.select();
        }
        Open_ProductSearch();
        break;
      }
      case "F2":
        e.preventDefault();
        if (!isConvertReturn) dispatch(ShowHide_Popup("IsPOSCustomer"));
        break;
      case "F3":
        e.preventDefault();
        dispatch(ShowHide_Popup("IsSession"));
        break;
      case "F4":
        e.preventDefault();
        Next_PaymentMode(1); // cycle Cash > Card > Bank > Wallet > UPI > Cash
        break;
      case "F5":
        e.preventDefault();
        if (_DT.arrEntDT.length > 0) focusRow(0);
        else {
          const box = document.getElementById("pro-search");
          if (box) box.focus();
        }
        break;
      case "F6":
        e.preventDefault();
        setisPosView(true);
        break;
      case "F8":
        e.preventDefault();
        if (_DT.arrEntDT.length > 0) setisDiscount(true);
        break;
      case "F9":
        e.preventDefault();
        if (_DT.arrEntDT.length > 0) setisAddNotes(true);
        break;
      default:
        break;
    }
  };
  // ✅ FIX: old table_keypress was called as (e, trIndex) with rowIndex undefined
  // (Delete sent iRowIndex=undefined to the server), assumed <input>s inside the
  // cells (there are none) and rows were not focusable, so it never ran.
  const row_keypress = (e, product, idx) => {
    const len = _DT.arrEntDT.length;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        focusRow((idx + 1) % len);
        break;
      case "ArrowUp":
        e.preventDefault();
        focusRow((idx - 1 + len) % len);
        break;
      case "Enter":
        e.preventDefault();
        View_ProductUnit(product, idx);
        break;
      case "Delete":
        e.preventDefault();
        Confirm_Remove(idx);
        break;
      default:
        break;
    }
  };
  const Confirm_Remove = (idx) => {
    const item = _DT.arrEntDT[idx];
    const name = item && item.proName ? item.proName : "this item";
    Ask_Question(
      dispatch,
      () => runGuarded(() => Remove_tableProduct(idx)),
      `Remove "${name}" from the invoice?`,
      true
    );
  };
  // ✅ FIX: the "Attribute" column was configured but always empty
  // (validatename() excluded attValues and nothing rendered it).
  const hasAttCol = (_Common.arrtransper || []).some(
    (c) => c.columnName === "attValues"
  );
  const Render_Cell = (dt, product) => {
    const val = product[dt.columnName];
    if (dt.columnName === "attValues") return val || "";
    if (dt.columnName === "manufactureDate" || dt.columnName === "expiryDate")
      return fmtDate(val);
    return converttodecimal(dt.datatype, val, 2);
  };
  const textalign = ["left", "right", "center"];

  //#endregion

  //#region  Product Methods
  const Add_NewProduct = async (Product, BatchPro) => {
    const ProInfo = Product.ProInfo ? Product.ProInfo[0] : Product;
    const SelectedProduct = store.getState().Transstates.Product;
    const Context = itemMutationContextRef.current;
    const ProductParams = {
      ...SelectedProduct,
      Remarks: { ...SelectedProduct.Remarks },
      Calculation: { ...SelectedProduct.Calculation },
    };
    productViewRequestRef.current += 1;

    return enqueueItemMutation(async () => {
      try {
        await Pre_Loading(dispatch, true);
        if (Context !== itemMutationContextRef.current) return;
        const Qty = Number(ProInfo && ProInfo.dQty);
        if (!ProInfo || !ProInfo.strProName) {
          await Show_Message(dispatch, "Please Select Product", "info");
        } else if (!Number.isFinite(Qty) || Qty <= 0) {
          await Show_Message(
            dispatch,
            "Quantity must be greater than zero",
            "info"
          );
        } else {
          // Build every active-cart field after earlier queued mutations finish.
          // Otherwise rapid scans can submit the same stale arrEntDT and the last
          // response replaces (rather than extends) the current invoice.
          const CurrentState = store.getState();
          const CurrentCommon = CurrentState.Transstates.Common;
          const CurrentHeader = CurrentState.Transstates.Header;
          const CurrentData = CurrentState.Transstates.Data;
          const CurrentDisc = CurrentState.Transstates.Discount; // A1
          const CurrentAuth = CurrentState.Common.Admin;
          const parems = {
            bUpdateStatus: false,
            iScrId: CurrentCommon.iScrId,
            iTaxRelId: CurrentHeader.iTaxRelId,
            iPartyId: CurrentHeader.iPartyId,
            iVouchId: CurrentHeader.iVouchId,
            iTaxCalcOnId: CurrentCommon.iTaxCalcOnId,
            iProId: ProInfo.iProId,
            strJobId: "0",
            iSerId: 0,
            iRowIndex: 0,
            iUnitId: Number(ProInfo.iUnitId),
            dQty: Qty,
            FQty: Number(ProInfo.dFQty),
            dPriceRate: Number(ProductParams.dRate),
            dPriceRateWithTax: Number(ProductParams.dRatewithTax),
            dDiscountPer: ProductParams.isItemDiscPer
              ? Number(ProductParams.dItemDisc)
              : 0,
            dDiscountAmt: ProductParams.isItemDiscPer
              ? 0
              : Number(ProductParams.dItemDisc),
            dCashDiscountPer:
              ProductParams.isCashDiscPer === true
                ? Number(ProductParams.dCashDisc)
                : 0,
            dCashDiscountAmt:
              ProductParams.isCashDiscPer === false
                ? Number(ProductParams.dCashDisc)
                : 0,
            BatchNo: BatchPro ? BatchPro.batchNo : ProInfo.batchNo,
            ManufactureDate: BatchPro ? BatchPro.mftDate : ProInfo.mftDate,
            ExpiryDate: BatchPro ? BatchPro.expDate : ProInfo.expDate,
            isComposPro: Number(ProInfo.isComposPro),
            isBatchPro: Number(ProInfo.isBatchPro),
            objBaseTransDT: CurrentData.arrEntDT,
            objItemRemark: ProductParams.Remarks,
            objRootCalc: ProductParams.Calculation,
            objPenCon: CurrentData.arrEntPenCon,
            objEntAddLess: CurrentData.arrEntAL,
            objEntConRow: [],
            objEntTax: CurrentData.arrEntTax,
            strSearch: "",
            strColumn: "",
            Reason: "",
            DimAttDTId: "0",
            iALBillDiscId: CurrentCommon.iALBillDiscId,
            strSetCurrentStatus: CurrentCommon.strCurrentStatus,
            // A1: discounts from Transstates.Discount (NaN-safe)
            ...Disc_TransParems(CurrentDisc),
            iYearId: Number(CurrentAuth.Year),
            iBranchId: Number(CurrentAuth.Branch),
            strDBName: CurrentAuth.DB,
            iUserid: Number(CurrentAuth.User),
          };
          const res = await API_POST(
            `ProductTrans/AddUpd_Product/`,
            parems,
            dispatch
          );
          if (res && Context === itemMutationContextRef.current) {
            dispatch(AddProduct(res));
            if (Array.isArray(res.EntDT) && res.EntDT.length > 0) {
              setTimeout(() => focusRow(res.EntDT.length - 1), 50);
            }
          }
        }
      } catch (e) {
        Show_Message(dispatch, e.message, "error");
      } finally {
        await Pre_Loading(dispatch, false);
      }
    });
  };
  const View_ProductUnit = async (ProInfo, Index) => {
    const requestId = ++productViewRequestRef.current;
    return enqueueItemMutation(async () => {
      try {
        await Pre_Loading(dispatch, true);
        const res = await API_FETCH(
          `ProductTrans/View_ProductUnit/${ProInfo.proId}/${_Common.strScrType}/${_AuthParems.DB}`,
          dispatch
        );
        if (res && requestId === productViewRequestRef.current) {
          await dispatch(
            Modify_Product({
              ProInfo: ProInfo,
              Unit: res.ProUnit,
              Index: Index,
            })
          );
          await dispatch(ShowHide_Popup("IsPosPro"));
        }
      } catch (e) {
        Show_Message(dispatch, e.message, "error");
      } finally {
        await Pre_Loading(dispatch, false);
      }
    });
  };
  const Remove_tableProduct = async (iIndex) => {
    const Context = itemMutationContextRef.current;
    productViewRequestRef.current += 1;
    return enqueueItemMutation(async () => {
      try {
        if (Context !== itemMutationContextRef.current) return;
        const CurrentState = store.getState();
        const CurrentCommon = CurrentState.Transstates.Common;
        const CurrentHeader = CurrentState.Transstates.Header;
        const CurrentData = CurrentState.Transstates.Data;
        const CurrentDisc = CurrentState.Transstates.Discount; // A1
        const CurrentAuth = CurrentState.Common.Admin;
        if (iIndex < 0 || iIndex >= CurrentData.arrEntDT.length) return;

        const res = await API_POST(
          `ProductTrans/Delete_tableProduct/`,
          {
            iRowIndex: iIndex,
            iScrId: CurrentCommon.iScrId,
            iALBillDiscId: CurrentCommon.iALBillDiscId,
            iTaxCalcOnId: CurrentCommon.iTaxCalcOnId,

            iTaxRelId: CurrentHeader.iTaxRelId,
            iPartyId: CurrentHeader.iPartyId,
            iVouchId: CurrentHeader.iVouchId,

            iProId: 0,
            iUnitId: 0,
            dQty: 0,
            dPriceRate: 0,
            dDiscountPer: 0,
            dDiscountAmt: 0,

            strSearch: "",
            strColumn: "",
            strReason: "",
            strJobId: "0",
            strSetCurrentStatus: "",

            strProAttDTId: "",
            strStoAttDTId: "",
            strTraAttDTId: "",
            objItemRemark: {},
            objRootCalc: {},

            // A1: discounts from Transstates.Discount (NaN-safe)
            ...Disc_TransParems(CurrentDisc),

            objPenCon: CurrentData.arrEntPenCon,
            objBaseTransDT: CurrentData.arrEntDT,
            objEntAddLess: CurrentData.arrEntAL,
            objEntConRow: [],
            objEntTax: CurrentData.arrEntTax,

            iYearId: Number(CurrentAuth.Year),
            iBranchId: Number(CurrentAuth.Branch),
            strDBName: CurrentAuth.DB,
            iUserId: Number(CurrentAuth.User),
          },
          dispatch
        );
        if (res && Context === itemMutationContextRef.current) {
          dispatch(Remove_product(res));
        }
      } catch (e) {
        await Show_Message(dispatch, e.message, "error");
      }
    });
  };

  //#endregion

  keyHandlerRef.current = short_cut_keypress;

  return (
    <div className="container-pos">
      <div className="pos-wrapper">
        <div className="possection">
          {/* ✅ FIX: PC screen had NO search box (only the hidden F1 key). */}
          {!isConvertReturn && (
            <div className="search-product">
              <div className="search-box">
                <input
                  type="text"
                  placeholder="Search Product or Scan Barcode (F1)"
                  defaultValue={strSearch}
                  onClick={() => Open_ProductSearch()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      Open_ProductSearch();
                    } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                      e.preventDefault();
                      if (_Common.IsTabletMode) $("[tabindex=0]").focus();
                      else focusRow(0);
                    }
                  }}
                  autoFocus
                  autoComplete="off"
                  id="pro-search"
                />
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
            </div>
          )}
          {isConvertReturn && <h3 className="return-product">Product Return</h3>}
          {!_Common.IsTabletMode && (
            <div className="pos-itemlist">
              <table className="product-table" ref={tableRef}>
                <thead>
                  <tr>
                    {(_Common.arrtransper || []).map((dt, Index) => (
                      <th
                        key={Index}
                        style={{
                          minWidth: dt.colLen + "px",
                          maxWidth: dt.colLen + "px",
                        }}
                      >
                        {dt.aliasName}
                      </th>
                    ))}
                    <th style={{ width: "40px", minWidth: "40px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {_DT.arrEntDT.map((product, trIndex) => (
                    <tr
                      key={trIndex}
                      ref={(el) => (rowRefs.current[trIndex] = el)}
                      tabIndex={-1}
                      onClick={(e) => {
                        View_ProductUnit(product, trIndex);
                      }}
                      onKeyDown={(e) => row_keypress(e, product, trIndex)}
                    >
                      {(_Common.arrtransper || []).map((dt, tdIndex) => (
                        <td
                          key={tdIndex}
                          style={{
                            minWidth: dt.colLen + "px",
                            maxWidth: dt.colLen + "px",
                            // ✅ FIX: "wrap" is not a valid CSS value -> use "normal"
                            whiteSpace: dt.isWordwrap ? "normal" : "nowrap",
                            textAlign: textalign[dt.textAlign - 1],
                          }}
                        >
                          {dt.columnName === "proName" && (
                            <>
                              {`${product.proName}`}
                              <br />
                              <span>
                                GST - {numtodecimal(product.taxPer)} % | Unit :{" "}
                                {product.unitName}
                                {/* attribute goes in the sub-line only when the
                                    grid has no "Attribute" column of its own */}
                                {!hasAttCol && product.attValues
                                  ? ` | ${product.attValues}`
                                  : ""}
                              </span>
                            </>
                          )}
                          {(validatename(dt.columnName) === true ||
                            dt.columnName === "attValues") && (
                            <>{Render_Cell(dt, product)}</>
                          )}
                        </td>
                      ))}
                      <td style={{ width: "40px", minWidth: "40px" }}>
                        <button
                          type="button"
                          title="Remove item (Delete)"
                          aria-label="Remove item"
                          style={{
                            background: "transparent",
                            border: "none",
                            color: "#d9534f",
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            Confirm_Remove(trIndex);
                          }}
                        >
                          <i className="fa-regular fa-trash-can"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {_Common.IsTabletMode && <MobileProductSearch />}
          <div className="pos-footer">
            <div className="info">
              <h2 className="infoheader">LAST BILL INFO</h2>
              <ul>
                <li>
                  <p>Inv No :</p>
                  <p>{_Common.LastInvNo || "-"}</p>
                </li>
                <li>
                  <p>Paid Amt : </p>
                  <p>
                    {fmtINR(_Common.dLBPaidAmt)}
                  </p>
                </li>
                <li>
                  <p>Pay Type : </p>
                  <p>{_Common.LasBillType || "-"}</p>
                </li>
                <li>
                  <p>Net Amt : </p>
                  <p>
                    {fmtINR(_Common.dLBNetAmt)}
                  </p>
                </li>
                <li>
                  <p>Balance : </p>
                  <p>
                    {fmtINR(_Common.dLBBalAmt)}
                  </p>
                </li>
                <li>
                  <p>Inv Date : </p>
                  <p>{_Common.LastInvDate || "-"}</p>
                </li>
              </ul>
            </div>
            <div className="pos-btn-grp">
              <button
                className="btn-fabgreen"
                disabled={_DT.arrEntDT.length > 0 ? false : true}
                onClick={(e) => setisOtherCharges(true)}
              >
                Other Charges
              </button>
              <button
                className="btn-fabgreen"
                disabled={_DT.arrEntDT.length > 0 ? false : true}
                title="Discount (F8)"
                onClick={(e) => setisDiscount(true)}
              >
                Discount
              </button>
              <button
                className="btn-fabgreen"
                disabled={_DT.arrEntDT.length > 0 ? false : true}
                onClick={(e) => setisDelivery(true)}
              >
                Delivery
              </button>
              <button
                className="btn-fabgreen"
                disabled={_DT.arrEntDT.length > 0 ? false : true}
                title="Notes (F9)"
                onClick={(e) => setisAddNotes(true)}
              >
                Notes
              </button>
              <button
                className="btn-fabgreen"
                disabled={
                  Number(_HT.iVouchId) === 0 || _HT.BtnDisable === true
                }
                onClick={(e) => {
                  if (Number(_HT.iVouchId) === 0) {
                    Show_Message(
                      dispatch,
                      "Please Select Voucher to Delete!",
                      "info"
                    );
                  } else {
                    // FIX: in return mode this used to call Delete_Invoice with the
                    // RETURN id => deleted the sales invoice that has the same number.
                    // Delete_Return was defined but never used.
                    Ask_Question(
                      dispatch,
                      () =>
                        runGuarded(
                          isConvertReturn ? Delete_Return : Delete_PosInvoice
                        ),
                      isConvertReturn
                        ? `Do You Want to Delete Sales Return ?`
                        : `Do You Want to Delete Invoice ?`,
                      true
                    );
                  }
                }}
              >
                Delete
              </button>
              <button
                className="btn-fabgreen"
                onClick={(e) =>
                  confirmDiscardCart(() => {
                    itemMutationContextRef.current += 1;
                    productViewRequestRef.current += 1;
                    Reset_CartContext(); // A1/A2: start the return from a clean cart
                    setisReturn(true);
                  })
                }
              >
                Return
              </button>
              <button
                className="btn-fabgreen"
                title="View Invoices (F6)"
                onClick={(e) => setisPosView(true)}
              >
                View
              </button>
            </div>
          </div>
        </div>
        <div className="possection">
          <div className="profile_view">
            <h1>{_Common.strScrName}</h1>
            <span className="profile-icon">
              <i
                className="bx bx-cog"
                title="Menu (Ctrl+A)"
                onClick={(e) => Open_RightMenu()}
              ></i>
            </span>
          </div>
          <div className="card party">
            <h2>Name : {_Customer.PartyName || "Walk-in Customer"}</h2>
            <h2>Mobile : {_Customer.Mobile || "-"}</h2>
            {!isConvertReturn && (
              <span
                role="button"
                tabIndex={0}
                title="Select Customer (F2)"
                aria-label="Select Customer"
                onClick={(e) => dispatch(ShowHide_Popup("IsPOSCustomer"))}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    dispatch(ShowHide_Popup("IsPOSCustomer"));
                  }
                }}
              >
                <i className="fa-solid fa-user-plus"></i>
              </span>
            )}
          </div>
          <div className="card staff">
            <h2>Billing Staff</h2>
            <div className="st">
              <i
                className="fa-solid fa-user-tie"
                title="Select Billing Staff"
                onClick={(e) => dispatch(ShowHide_Popup("IsEmployee"))}
              ></i>
              <sub>+</sub>
            </div>
            <div className="text">
              <label>
                {_Employee.strEmployeeName || "Not selected"} <br />
                <span>{_Employee.strEmpRole}</span>
              </label>
              <label>Reward Point : {_Employee.dRewardPoint}</label>
            </div>
          </div>
          <div className="card sum">
            <h2>Summary</h2>
            <div className="text">
              <p>Sub Total</p>
              <p>
                {fmtINR(Number(_Sum.GoodsValue))}
              </p>
            </div>
            <div className="text">
              <p>GST</p>
              <p>
                {fmtINR(Number(_Sum.Tax))}
              </p>
            </div>
            <div className="text">
              <p>Discount</p>
              <p>
                {fmtINR(Number(_Sum.Discount))}
              </p>
            </div>
            {/* A1: the reducer writes strCouponCode (strCoupon never existed here) */}
            {(_Disc.strCouponCode || "").length > 0 && (
              <div className="text">
                <p
                  style={{
                    width: "100%",
                    color: "green",
                    fontSize: "12px",
                    textAlign: "right",
                  }}
                >
                  {/* ✅ FIX: was `{Per + Amt}% Coupon Discount Applied` — Per and
                      Amt are mutually exclusive (only one is ever non-zero, same
                      pattern as item-level discount), so adding them and always
                      labeling it "%" showed e.g. "50% Coupon Discount Applied"
                      for a plain ₹50 amount-based coupon. */}
                  {num(_Disc.dCouponDiscPer) > 0
                    ? `${num(_Disc.dCouponDiscPer)}%`
                    : fmtINR(num(_Disc.dCouponDiscAmt))}{" "}
                  Coupon Discount Applied
                </p>
              </div>
            )}
            <div className="text">
              <p>Other Charges</p>
              <p>
                {fmtINR(Number(_Sum.AddLess))}
              </p>
            </div>
            <div className="text">
              <p>Round Off</p>
              <p>
                {fmtINR(Number(_Sum.RoundOff))}
              </p>
            </div>
            <div className="text">
              <p>
                TOTAL
                <br />
                <span>
                  (Item : {_DT.arrEntDT.length},Qty : {_Sum.Qty})
                </span>
              </p>
              <p>
                {fmtINR(Number(_Sum.NetAmt))}
              </p>
            </div>
          </div>
          <div className="card">
            <h2>Payment</h2>
            <div className="Payment" id="btn-paymt">
              {PAY_MODES.map((id, i) => (
                <button
                  key={id}
                  type="button"
                  ref={(el) => (payRefs.current[i] = el)}
                  className={
                    Number(_HT.iBillTypeId) === id ? "icon active" : "icon"
                  }
                  title={`${PAY_LABELS[id]} (F4)`}
                  aria-label={PAY_LABELS[id]}
                  aria-pressed={Number(_HT.iBillTypeId) === id}
                  onClick={(e) => Update_PaymentMode(id)}
                  onKeyDown={(e) => {
                    if (e.key === "ArrowLeft") {
                      e.preventDefault();
                      Next_PaymentMode(-1);
                    }
                    if (e.key === "ArrowRight") {
                      e.preventDefault();
                      Next_PaymentMode(1);
                    }
                  }}
                >
                  {id === 8 ? <p>UPI</p> : <i className={PAY_ICONS[id]}></i>}
                </button>
              ))}
            </div>
          </div>
          <div className="pos-sum-btn">
            <button
              className="btn-fabgreen"
              ref={buttonclear}
              title="Clear Invoice (Ctrl+E)"
              onClick={Clear_Click}
            >
              <span>
                <i className="fa-solid fa-eraser mr-2"></i> Clear Invoice
              </span>
            </button>
            <button
              className="btn-fabgreen"
              ref={buttonsave}
              disabled={_DT.arrEntDT.length > 0 && !isSaving ? false : true}
              title="Save (Ctrl+S)"
              onClick={Save_Click}
            >
              <span>
                <i className="fa-regular fa-floppy-disk mr-2"></i>
                {isConvertReturn ? "Save Return" : "Save Invoice"}
              </span>
            </button>
          </div>
        </div>
        {_Common.IsRightMenu && <Posrightmenu />}
        {_Common.IsPOSCustomer && <CustomerSearch />}
        {_Common.IsEmployee && <StaffProfile />}
        {_Common.IsPosPro && <PosproductInput />}
        {_Common.IsProRemark && <ItemRemarks />}
        {_Common.IsProCal && <RootCalculation />}
        {_Common.IsSession && (
          <Sessionopenclose SessionOpen={Load_PosInvoice} />
        )}
        {_Common.IsProSearch && (
          <TransProductSearch Add_NewProduct={Add_NewProduct} />
        )}
        {_Common.IsBatchPro && (
          <BatchProductSearch Add_NewProduct={Add_NewProduct} />
        )}
        {_Common.IsAttPro && (
          <AttributeProductSearch Add_NewProduct={Add_NewProduct} />
        )}
        {isReceipt && (
          <Receipt
            Close={(e) => setisReceipt(false)}
            PayMode={Number(_HT.iBillTypeId)}
            NetAmt={Number(_Sum.NetAmt)}
            Save_Invoice={(e) => runGuarded(() => Save_Invoice(false, e))}
          />
        )}
        {isDelivery && (
          <DeliveryOption Close={(e) => setisDelivery(false)} />
        )}
        {isPosView && (
          <PosView
            Close={(e) => setisPosView(false)}
            PrintSettings={() => dispatch(ShowHide_Popup("IsPrintSett"))}
            ViewInvoice={View_posinvoice}
            PrintVoucher={(VouchId, PrintFor) =>
              Print_POSVoucher(VouchId, 93, PrintFor)
            }
            ShareVoucher={(VouchId, Type) =>
              Open_POSShare(VouchId, 93, Type)
            }
            Return={(PosInvId) =>
              confirmDiscardCart(() => {
                itemMutationContextRef.current += 1;
                productViewRequestRef.current += 1;
                Reset_CartContext(); // A1/A2: start the return from a clean cart
                setisPosView(false);
                setisProReturn(true);
                setiVouchId(PosInvId);
              })
            }
          />
        )}

        {isReturn && (
          <POSReturn
            Close={(e) => setisReturn(false)}
            PrintVoucher={(VouchId, PrintFor) =>
              Print_POSVoucher(VouchId, 96, PrintFor)
            }
            ShareVoucher={(VouchId, Type) =>
              Open_POSShare(VouchId, 96, Type)
            }
            View_Return={() => {
              setisReturn(false);
              setisConvertReturn(true);
            }}
          />
        )}
        {isProReturn && (
          <ProductReturn
            Close={(e) => {
              setiVouchId(0);
              setisProReturn(false);
            }}
            VouchId={iVouchId}
            View_Return={(arrperm) => {
              itemMutationContextRef.current += 1;
              productViewRequestRef.current += 1;
              setiVouchId(0);
              setisConvertReturn(true);
              setisProReturn(false);
              setarrEntPermission(arrperm);
            }}
          />
        )}
        {isOtherCharges && (
          <OtherCharges Close={(e) => setisOtherCharges(false)} />
        )}
        {isDiscount && <Discount Close={(e) => setisDiscount(false)} />}
        {isAddNotes && <Notes Close={(e) => setisAddNotes(false)} />}
        {posShareRequest?.Type === "Email" && (
          <EmailPopup
            Close={() => setposShareRequest(null)}
            iVouchId={posShareRequest.iVouchId}
            iScrId={posShareRequest.iScrId}
            ScrName={posShareRequest.iScrId === 96 ? "Sales Return" : "Sales Invoice"}
          />
        )}
        {posShareRequest?.Type === "WhatsApp" && (
          <WhatsApp
            Close={() => setposShareRequest(null)}
            iVouchId={posShareRequest.iVouchId}
            iScrId={posShareRequest.iScrId}
            ScrName={posShareRequest.iScrId === 96 ? "Sales Return" : "Sales Invoice"}
          />
        )}
        {_Common.IsPrintSett && <PrinterSetting />}
        <Messagedialogbox />
      </div>
    </div>
  );
}
export default Pointofsales;

// import { useDispatch, useSelector } from "react-redux";
// import $ from "jquery";
// import {
//   Add_TransHtparem,
//   Add_CommonDefault,
//   Add_TransSummary,
//   Add_party,
//   Add_Transdata,
//   add_BillDiscount,
//   Clear_invoice,
//   setothercharges,
// } from "../features/POS";
// import PosView from "./PosView";
// import Notes from "./Notes";
// import OtherCharges from "./OtherCharges";
// import CustomerSearch from "./CustomerSearch";
// import Sessionopenclose from "./Sessionopenclose";
// import Receipt from "./Receipt";
// import DeliveryOption from "./DeliveryOption";
// import Posrightmenu from "./Posrightmenu";
// import {
//   Ask_Question,
//   Pre_Loading,
//   Show_Message,
// } from "../General/Messagedialogbox";
// import Messagedialogbox from "../General/Messagedialogbox";
// import Discount from "./Discount";
// import StaffProfile from "./StaffProfile";
// import ProductReturn from "./ProductReturn";
// import POSReturn from "./POSReturn";
// import MobileProductSearch from "./MobileProductSearch";
// import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
// import { Update_AdminCntrl } from "../features/CommonStates";
// import {
//   AddProduct,
//   Clear_Transaction,
//   Modify_POSVouchers,
//   Modify_Product,
//   Remove_product,
//   ShowHide_Popup,
//   Update_BillType,
//   setPOS_DefaultParems,
// } from "../features/Transactionstates";
// import TransProductSearch from "../Transaction/TransProductSearch";
// import BatchProductSearch from "../Transaction/BatchProductSearch";
// import AttributeProductSearch from "../Transaction/AttributeProductSearch";
// import { TransConfig } from "../Transaction/Transaction";
// import PosproductInput from "./PosproductInput";
// import ItemRemarks from "../Transaction/ItemRemarks";
// import RootCalculation from "../Transaction/RootCalculation";

// function Pointofsales() {
//   const dispatch = useDispatch();
//   const _AuthParems = useSelector((state) => state.Common.Admin);
//   const tableRef = useRef(null);
//   const buttonsave = useRef();
//   const buttoncard = useRef();
//   const buttonclear = useRef();

//   //#region  Redonly Parem from Global Redux Storage
//   const _Common = useSelector((store) => store.Transstates.Common);
//   const _HT = useSelector((store) => store.Transstates.Header);
//   const _DT = useSelector((state) => state.Transstates.Data);
//   const _Sum = useSelector((state) => state.Transstates.Summary);
//   const _Employee = useSelector((state) => state.Transstates.Employee);
//   const _Product = useSelector((state) => state.Transstates.Product);
//   const _Pos = useSelector((state) => state.Pointofsales.Pos);
//   const _Customer = useSelector((state) => state.Transstates.Customer);
//   const _Disc = useSelector((state) => state.Pointofsales.BillDiscount);
//   //#endregion

//   //#region Default parems
//   const [strSearch, setstrSearch] = useState("");
//   const [isDiscount, setisDiscount] = useState(false);
//   const [iVouchId, setiVouchId] = useState(0);
//   const [isConvertReturn, setisConvertReturn] = useState(false);
//   const [arrEntPermission, setarrEntPermission] = useState([]);
//   //#endregion

//   //#region Popup Parems
//   const [isPosView, setisPosView] = useState(false);
//   const [isAddNotes, setisAddNotes] = useState(false);
//   const [isOtherCharges, setisOtherCharges] = useState(false);
//   const [isReceipt, setisReceipt] = useState(false);
//   const [isAddtoCart, setisAddtoCart] = useState(false);
//   const [isDelivery, setisDelivery] = useState(false);
//   const [isReturn, setisReturn] = useState(false);
//   const [isProReturn, setisProReturn] = useState(false);
//   //#endregion
//   const _ScrId = 93;

//   useEffect(() => {
//     Load_PosInvoice();
//     document.addEventListener("keydown", short_cut_keypress);
//     return () => {
//       document.removeEventListener("keydown", short_cut_keypress);
//     };
//   }, []);
//   const Load_PosInvoice = async () => {
//     const _LocalParems = await DecryptData(localStorage.jbctrlparams);
//     try {
//       await Pre_Loading(dispatch, true);

//       const config = TransConfig(_ScrId);
//       const objTrans = await {
//         strController: config.Controller,
//         strScrType: config.strScrType,
//         iScrId: config.iScrId,
//         strScrName: config.strScrName,
//         iPartyScrId: 2,
//         iPartyId: 0,
//         iVenType: 0,
//         strSearch: "",
//         strColName: "",
//         strDBName: _LocalParems.DB,
//         iClientId: Number(_LocalParems.Client),
//         iUserId: Number(_LocalParems.User),
//         iRoleId: Number(_LocalParems.Role),
//         iBranchId: Number(_LocalParems.Branch),
//         iCounterId: Number(_LocalParems.Counter),
//         iSessionId: Number(_LocalParems.Session),
//       };
//       const res = await API_POST(`POS/Load_Invoice/`, objTrans, dispatch);
//       if (res) {
//         if (Number(res.POS.counterId) === 0)
//           Show_Message(
//             dispatch,
//             "Please Update Counter for Current User",
//             "info"
//           );
//         else {
//           res.Transparem = objTrans;
//           await dispatch(setPOS_DefaultParems(res));
//           if (Number(res.POS.sessionId) === 0)
//             await dispatch(ShowHide_Popup("IsSession"));
//           _LocalParems.Session = Number(res.POS.sessionId);
//         }
//       }
//     } catch (err) {
//       Show_Message(dispatch, err.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//       await dispatch(Update_AdminCntrl(_LocalParems));
//     }
//   };

//   //#region  Click Event
//   const Save_Invoice = async (ObjReceipt) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       let URL = "POS/InsUpd_Invoice/";
//       setisReceipt(!isReceipt);
//       let ReceiptDt = {
//         strPrefix: "",
//         iNumSeqNo: 0,
//         strCompCode: "",
//         strFinanFrom: "",
//         strRecNo: "",
//         strTransNo: "",
//         dpRecDate: _HT.strVouchDate,
//         iVenType: 5,
//         iVenId: _Customer.iPartyId,
//         iPayModeId: _HT.iBillTypeId,
//         dAmount: ObjReceipt.dAmount,
//         iVouchId: 0,
//         iBankAccId: ObjReceipt.iBankAccId,
//         strChequeNo: ObjReceipt.strChequeNo,
//         dpChequeDate: ObjReceipt.strChequeDate,
//         strAccNo: ObjReceipt.strAccNo,
//         strAccHolderName: ObjReceipt.strAccHolderName,
//         strPrintName: ObjReceipt.strPrintName,
//         strRemark: ObjReceipt.strRemark,
//         iBNId: ObjReceipt.iBankId,
//         iRecId: 0,
//         iCallerScrId: 93,
//         strBankName: "",
//         strFilter: "",
//         strFilterColumn: "",
//         strSearch: "",
//         strVenName: "",
//         strDBName: _AuthParems.DB,
//         iSessionId: Number(_AuthParems.Session),
//       };
//       const POSInvListHT = {
//         iPosInvId: _HT.iVouchId,
//         iTitleTag: _Common.iScrId,
//         iPartyId: _Customer.PartyId,
//         strShippingAdd: _Customer.ShippAdd,
//         iNumSeqNo: 0,
//         strPrefix: "",
//         strCompCode: "",
//         strFinanFrom: "",
//         strTransNo: "",
//         strVouchNo: _HT.strVouchNo,
//         strVouchDate: _HT.strVouchDate,
//         iAddLessBillDiscId: _Disc.iALBillDiscId,
//         iBillTypeId: _HT.iBillTypeId,
//         iTaxCalcOnId: Number(_Pos.iTaxCalcOnId),
//         iTaxTypeId: Number(_HT.iTaxRelId),
//         iDMId: _HT.iDMId,
//         strRefNum1: _HT.strRefNum1,
//         dpRefNum1Date: _HT.dpRefNum1Date,
//         strRefNum2: _HT.strRefNum2,
//         dpRefNum2Date: _HT.dpRefNum2Date,
//         strRefNum3: _HT.strRefNum3,
//         dpRefNum3Date: _HT.dpRefNum3Date,
//         strRefNum4: _HT.strRefNum4,
//         dpRefNum4Date: _HT.dpRefNum4Date,
//         strRemark1: _HT.strRemark1,
//         strRemark2: _HT.strRemark2,
//         strRemark3: _HT.strRemark3,
//         strRemark4: _HT.strRemark4,
//         strValidity: _HT.strValidity,
//         dpValDateUpto: _HT.dpValDateUpto,
//         strPayTerm: _HT.strPayTerm,
//         dpPayTermDateUpto: _HT.dpPayTermDateUpto,
//         strDeliTerm: _HT.strDeliTerm,
//         dpDelTermDateUpto: _HT.dpDelTermDateUpto,

//         strTransport: _HT.strTransport,
//         strVehicle: _HT.strVehicle,
//         strDespatch: _HT.strDespatch,
//         dpDespatchDate: _HT.dpDespatchDate,
//         strLRNNumber: _HT.strLRNNumber,
//         dpLRNoDate: _HT.dpLRNoDate,
//         strAgent: _HT.strAgent,
//         strReference: _HT.strReference,
//         strDestination: _HT.strDestination,

//         dTBillDiscPer: Number(_Disc.dBillDisPer),
//         dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//         dTBillDiscValue: Number(_Disc.dBillDisValue),
//         dTAddLessDiscPer: Number(_Disc.dALBillDisPer),
//         dTAddLessDiscAmt: Number(_Disc.dALBillDisAmt),
//         dTAddLessDiscValue: Number(_Disc.dALBillDisValue),

//         dTotQty: Number(_Sum.Qty),
//         dTotGoodval: Number(_Sum.GoodsValue),
//         dTotDiscount: Number(_Sum.Discount),
//         dTotTax: Number(_Sum.Tax),
//         dAddLess: Number(_Sum.AddLess),
//         dTotTCSTax: Number(_Sum.TCSTax),
//         dRoundOff: Number(_Sum.RoundOff),
//         dNetAmt: Number(_Sum.NetAmt),
//         dRoyaltyPoint: Number(_Disc.dRewardPointAmt),
//         iCouponId: Number(_Disc.iCouponId),
//         iUserId: Number(_AuthParems.User),
//         iEmpId: Number(_Employee.iEmpId),
//         iYearId: Number(_AuthParems.Year),
//         strDBName: _AuthParems.DB,
//         iSessionId: Number(_AuthParems.Session),
//         iBranchId: Number(_AuthParems.Branch),
//       };
//       const cust = {
//         iCustId: _Customer.PartyId,
//         CustName: _Customer.PartyName,
//         Add1: _Customer.Address1,
//         Add2: _Customer.Address2,
//         Add3: _Customer.Address3,
//         Add4: _Customer.Address4,
//         Pincode: _Customer.Pincode,
//         State: _Customer.State,
//         Country: _Customer.Country,
//         Mobile: _Customer.Mobile,
//         Mobile1: "",
//         Phone1: _Customer.Phone,
//         Phone2: "",
//         Email: _Customer.Email,
//         GST: _Customer.GST,
//         Remark: _Customer.Remark,
//         ShippAdd: _Customer.ShippAdd,
//         IsSameAdd: _Customer.IsSameAdd,
//         RoyaltyPoint: _Customer.RoyaltyPoint,
//         Status: _Customer.Status,
//         CreatedBy: Number(_Employee.iEmpId),
//       };
//       const res = await API_POST(
//         URL,
//         {
//           objEntPos: POSInvListHT,
//           objTransDT: _DT.arrEntDT,
//           objDTHelp: _DT.arrEntDTHelp,
//           objEntALDT: _DT.arrEntAL,
//           objEntTax: _DT.arrEntTax,
//           objEntCust: cust,
//           objEntReceipt: ReceiptDt,
//         },
//         dispatch
//       );
//       if (res) {
//         Show_Message(dispatch, res.strMessage, "success");
//         CancelInvoice();
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "success");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const Save_Return = async () => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const ReturnHT = {
//         iPOSRetId: _HT.iVouchId,
//         iTitleTag: 96,
//         iPartyId: _Customer.PartyId,
//         strShippingAdd: _Customer.ShippAdd,
//         strVouchNo: _HT.strVouchNo,
//         strVouchDate: _HT.strVouchDate,
//         iAddLessBillDiscId: _Disc.iALBillDiscId,
//         iBillTypeId: _HT.iBillTypeId,
//         iTaxCalcOnId: Number(_Pos.iTaxCalcOnId),
//         iTaxTypeId: Number(_HT.iTaxRelId),
//         iDMId: _HT.iDMId,
//         strConvertDCVouch: _HT.strConvertDCVouch,
//         strPartyDCVouch: _HT.strPartyDCVouch,
//         strRefNum1: _HT.strRefNum1,
//         dpRefNum1Date: _HT.dpRefNum1Date,
//         strRefNum2: _HT.strRefNum2,
//         dpRefNum2Date: _HT.dpRefNum2Date,
//         strRefNum3: _HT.strRefNum3,
//         dpRefNum3Date: _HT.dpRefNum3Date,
//         strRefNum4: _HT.strRefNum4,
//         dpRefNum4Date: _HT.dpRefNum4Date,
//         strRemark1: _HT.strRemark1,
//         strRemark2: _HT.strRemark2,
//         strRemark3: _HT.strRemark3,
//         strRemark4: _HT.strRemark4,
//         strValidity: _HT.strValidity.toString(),
//         dpValDateUpto: _HT.dpValDateUpto,
//         strPayTerm: _HT.strPayTerm.toString(),
//         dpPayTermDateUpto: _HT.dpPayTermDateUpto,
//         strDeliTerm: _HT.strDeliTerm.toString(),
//         dpDelTermDateUpto: _HT.dpDelTermDateUpto,

//         strEComGstNo: _HT.strEComGstNo,
//         strTransport: _HT.strTransport,
//         strVehicle: _HT.strVehicle,
//         strDespatch: _HT.strDespatch,
//         dpDespatchDate: _HT.dpDespatchDate,
//         strLRNNumber: _HT.strLRNNumber,
//         dpLRNoDate: _HT.dpLRNoDate,
//         strAgent: _HT.strAgent,
//         strReference: _HT.strReference,
//         strDestination: _HT.strDestination,

//         dTBillDiscPer: Number(_Disc.dBillDisPer),
//         dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//         dTBillDiscValue: Number(_Disc.dBillDisValue),
//         dTAddLessDiscPer: Number(_Disc.dALBillDisPer),
//         dTAddLessDiscAmt: Number(_Disc.dALBillDisAmt),
//         dTAddLessDiscValue: Number(_Disc.dALBillDisValue),

//         dTotQty: Number(_Sum.Qty),
//         dTotGoodval: Number(_Sum.GoodsValue),
//         dTotDiscount: Number(_Sum.Discount),
//         dTotTax: Number(_Sum.Tax),
//         dAddLess: Number(_Sum.AddLess),
//         dTotTCSTax: Number(_Sum.TCSTax),
//         dRoundOff: Number(_Sum.RoundOff),
//         dNetAmt: Number(_Sum.NetAmt),
//         dRoyaltyPoint: Number(_Disc.dRewardPointAmt),
//         iCouponId: Number(_Disc.iCouponId),
//         iUserId: Number(_AuthParems.User),
//         iEmpId: Number(_Employee.iEmpId),
//         FYid: Number(_AuthParems.Year),
//         strDBName: _AuthParems.DB,
//         iSessionId: Number(_AuthParems.Session),
//         iBranchId: Number(_AuthParems.Branch),
//       };
//       const res = await API_POST(
//         "POS/InsUpd_Return",
//         {
//           objEntPos: ReturnHT,
//           objBaseTransDT: _DT.arrEntDT,
//           objDTHelp: _DT.arrEntDTHelp,
//           objEntALDT: _DT.arrEntAL,
//           objEntTax: _DT.arrEntTax,
//         },
//         dispatch
//       );
//       if (res) {
//         Show_Message(dispatch, res.strMessage, "success");
//         CancelInvoice();
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "success");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const Delete_Invoice = async () => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const res = await API_POST(
//         `POS/Delete_Invoice/${Number(_HT.iVouchId)}/${Number(
//           _AuthParems.Branch
//         )}/${_AuthParems.DB}`,
//         dispatch
//       );
//       if (res) {
//         Show_Message(dispatch, res.strMessage, "info");
//         CancelInvoice();
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "success");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const Delete_Return = async () => {
//     const res = await API_POST(
//       `POS/Delete_Return/${Number(_HT.iVouchId)}/${Number(
//         _AuthParems.Branch
//       )}/${_AuthParems.DB}`,
//       dispatch
//     );
//     if (res) {
//       Show_Message(dispatch, res.strMessage, "info");
//       CancelInvoice();
//     }
//   };
//   const CancelInvoice = () => {
//     setisAddtoCart(false);
//     setisConvertReturn(false);
//     dispatch(Clear_Transaction());
//     Load_PosInvoice();
//   };
//   const Show_Receipt = () => {
//     setisReceipt(!isReceipt);
//   };
//   //#endregion

//   //#region  View Methods
 
//   //#endregion

//   //#region Common Methods

//   const Update_PaymentMode = (PayId) => {
//     dispatch(Update_BillType(PayId));
//     let index = 0;
//     switch (PayId) {
//       case 6:
//         index = 1;
//         break;
//       case 4:
//         index = 2;
//         break;
//       case 7:
//         index = 3;
//         break;
//       case 8:
//         index = 4;
//         break;
//       default:
//         index = 0;
//         break;
//     }
//     $(`.Payment .icon:eq(${index})`).focus();
//     $(`.Payment .icon:eq(${index})`)
//       .toggleClass("active")
//       .siblings()
//       .removeClass("active");
//   };
//   const validatename = (columnName) => {
//     switch (columnName) {
//       case "proName":
//       case "unitName":
//       case "attValues":
//       case "taxPer":
//         return false;
//       default:
//         return true;
//     }
//   };
//   const converttodecimal = (type, value, len) => {
//     switch (type) {
//       case "Decimal":
//         return Number(value).toFixed(len);
//       case "Int32":
//         return Number(value);
//       default:
//         return value;
//     }
//   };
//   const numtodecimal = (num) => {
//     return Number(num).toFixed(2);
//   };
//   const short_cut_keypress = async (e) => {
//     switch (e.key) {
//       case "F1":
//         e.preventDefault();
//         $("#pro-search").focus();
//         $("#pro-search").select();
//         dispatch(ShowHide_Popup("IsProSearch"));
//         break;
//       case "F2":
//         e.preventDefault();
//         await dispatch(ShowHide_Popup("IsPOSCustomer"));
//         break;
//       case "F3":
//         e.preventDefault();
//         dispatch(ShowHide_Popup("IsSession"));
//         break;
//       case "F4":
//         e.preventDefault();
//         var index = $("#btn-paymt .icon.active").index();
//         switch (index) {
//           case 1:
//             Update_PaymentMode(6);
//             break;
//           case 2:
//             Update_PaymentMode(4);
//             break;
//           case 3:
//             Update_PaymentMode(7);
//             break;
//           case 4:
//             Update_PaymentMode(8);
//             break;
//           default:
//             Update_PaymentMode(2);
//             break;
//         }
//         break;
//       case "F5":
//         e.preventDefault();
//         $(".product-table tbody tr:eq(0) td input:eq(0)").focus();
//         $(".product-table tbody tr:eq(0) td input:eq(0)").select();
//         break;
//       case "F6":
//         e.preventDefault();
//         setisPosView(true);
//         break;
//       case "F8":
//         e.preventDefault();
//         setisDiscount(true);
//         break;
//       case "F9":
//         e.preventDefault();
//         setisAddNotes(true);
//         break;
//       default:
//         break;
//     }
//     if (e.ctrlKey && e.key === "s") {
//       e.preventDefault();
//       buttonsave.current.click();
//     }
//     if (e.ctrlKey && e.key === "h" && !isAddtoCart) {
//       e.preventDefault();
//       buttoncard.current.click();
//     }
//     if (e.ctrlKey && e.key === "e" && !isAddtoCart) {
//       e.preventDefault();
//       buttonclear.current.click();
//     }
//     if (e.ctrlKey && e.key === "a") {
//       e.preventDefault();
//       $("#pos-menu").addClass("active");
//     }
//     if (e.ctrlKey && e.shiftKey) {
//       e.preventDefault();
//       window.location.reload();
//     }
//   };
//   const table_keypress = (e, tabindex, rowIndex) => {
//     const table = tableRef.current;
//     const row = table.rows[1];
//     const inputElements = row.querySelectorAll("input");
//     let Enttabindex = [];
//     for (let i = 0; i < inputElements.length; i++) {
//       Enttabindex.push(inputElements[i].tabIndex);
//     }
//     let ProCount = _DT.arrEntDT.length;
//     const strQuery = ".product-table tbody tr:nth-child(";
//     const maxindex = Math.max(...Enttabindex);
//     const minindex = Math.min(...Enttabindex);
//     switch (e.key) {
//       case "ArrowUp":
//         rowIndex = rowIndex + 1;
//         Enttabindex = Enttabindex.sort((a, b) => b - a);
//         const PrevInput = Enttabindex.filter((dt) => dt < tabindex);
//         if (e.shiftKey) {
//           if (rowIndex === 1) {
//             $(`${strQuery}${ProCount}) input[tabindex="${tabindex}"]`)
//               .focus()
//               .select();
//           } else {
//             $(`${strQuery}${rowIndex - 1}) input[tabindex="${tabindex}"]`)
//               .focus()
//               .select();
//           }
//         } else {
//           if (minindex === tabindex && rowIndex === 1) {
//             $(`${strQuery}${ProCount}) input[tabindex="${maxindex}"]`)
//               .focus()
//               .select();
//           } else if (minindex === tabindex && rowIndex !== 1) {
//             $(`${strQuery}${rowIndex - 1}) input[tabindex="${maxindex}"]`)
//               .focus()
//               .select();
//           } else {
//             $(`${strQuery}${rowIndex}) input[tabindex="${PrevInput[0]}"]`)
//               .focus()
//               .select();
//           }
//         }
//         break;
//       case "ArrowDown":
//         rowIndex = rowIndex + 1;
//         Enttabindex = Enttabindex.sort((a, b) => a - b);
//         const nextInput = Enttabindex.filter((dt) => dt > tabindex);
//         if (e.shiftKey) {
//           if (rowIndex === ProCount) {
//             $(`${strQuery}1) input[tabindex="${tabindex}"]`).focus().select();
//           } else {
//             $(`${strQuery}${rowIndex + 1}) input[tabindex="${tabindex}"]`)
//               .focus()
//               .select();
//           }
//         } else {
//           if (maxindex === tabindex && rowIndex === ProCount) {
//             $(`${strQuery}1) input[tabindex="${minindex}"]`).focus().select();
//           } else if (maxindex === tabindex && rowIndex !== ProCount) {
//             $(`${strQuery}${rowIndex + 1}) input[tabindex="${minindex}"]`)
//               .focus()
//               .select();
//           } else {
//             $(`${strQuery}${rowIndex}) input[tabindex="${nextInput[0]}"]`)
//               .focus()
//               .select();
//           }
//         }
//         break;
//       case "Delete":
//         if (ProCount > 0) Remove_tableProduct(rowIndex);
//         break;
//       case "F1":
//         dispatch(ShowHide_Popup("IsProRemark"));
//         break;
//       case "F3":
//         dispatch(ShowHide_Popup("IsProCal"));
//         break;
//       default:
//         break;
//     }
//   };
//   const textalign = ["left", "right", "center "];

//   //#endregion

//   //#region  Product Methods
//   const Add_NewProduct = async (Product, BatchPro) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const ProInfo = Product.ProInfo ? Product.ProInfo[0] : Product;
//       if (ProInfo.strProName.length === 0) {
//         $("#txtproName").on("focus");
//         await Show_Message(dispatch, "Please Select Product", "info");
//       } else {
//         const parems = {
//           bUpdateStatus: false,
//           iScrId: _Common.iScrId,
//           iTaxRelId: _HT.iTaxRelId,
//           iPartyId: _HT.iPartyId,
//           iVouchId: _HT.iVouchId,
//           iTaxCalcOnId: _Common.iTaxCalcOnId,
//           iProId: ProInfo.iProId,
//           strJobId: "0",
//           iSerId: 0,
//           iRowIndex: 0,
//           iUnitId: Number(ProInfo.iUnitId),
//           dQty: Number(ProInfo.dQty),
//           FQty: Number(ProInfo.dFQty),
//           dPriceRate: Number(_Product.dRate),
//           dPriceRateWithTax: Number(_Product.dRatewithTax),
//           dDiscountPer: _Product.isItemDiscPer ? Number(_Product.dItemDisc) : 0,
//           dDiscountAmt: _Product.isItemDiscPer ? 0 : Number(_Product.dItemDisc),
//           dCashDiscountPer:
//             _Product.isCashDiscPer === false ? Number(_Product.dCashDisc) : 0,
//           dCashDiscountAmt:
//             _Product.isCashDiscPer === true ? Number(_Product.dCashDisc) : 0,
//           BatchNo: BatchPro ? BatchPro.batchNo : ProInfo.batchNo,
//           ManufactureDate: BatchPro ? BatchPro.mftDate : ProInfo.mftDate,
//           ExpiryDate: BatchPro ? BatchPro.expDate : ProInfo.expDate,
//           isComposPro: Number(ProInfo.isComposPro),
//           isBatchPro: Number(ProInfo.isBatchPro),
//           objBaseTransDT: _DT.arrEntDT,
//           objItemRemark: _Product.Remarks,
//           objRootCalc: _Product.Calculation,
//           objPenCon: _DT.arrEntPenCon,
//           objEntAddLess: _DT.arrEntAL,
//           objEntConRow: [],
//           objEntTax: _DT.arrEntTax,
//           strSearch: "",
//           strColumn: "",
//           Reason: "",
//           DimAttDTId: "0",
//           iALBillDiscId: _Common.iALBillDiscId,
//           strSetCurrentStatus: _Common.strCurrentStatus,
//           dAddLessDiscValue: Number(_Disc.dALBillDisValue),
//           dTBillDiscPer: Number(_Disc.dBillDisPer),
//           dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//           dCouponDiscPer: Number(_Disc.dCouponDiscPer),
//           dRewardPointper: Number(_Disc.dRewardPointper),
//           dCouponDiscAmt: Number(_Disc.dCouponDiscAmt),
//           dRewardPointAmt: Number(_Disc.dRewardPointAmt),
//           iYearId: Number(_AuthParems.Year),
//           iBranchId: Number(_AuthParems.Branch),
//           WHId: Number(Product.WHId),
//           strDBName: _AuthParems.DB,
//           iUserid: Number(_AuthParems.User),
//         };
//         const res = await API_POST(
//           `ProductTrans/AddUpd_Product/`,
//           parems,
//           dispatch
//         );
//         if (res) {
//           await dispatch(AddProduct(res));
//           $(`.product-table tbody tr:eq(${res.EntDT.length - 1}) input:eq(0)`)
//             .focus()
//             .select();
//         }
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const View_ProductUnit = async (ProInfo, Index) => {
//     try {
//       await Pre_Loading(dispatch, true);
//       const res = await API_FETCH(
//         `ProductTrans/View_ProductUnit/${ProInfo.proId}/${_Common.strScrType}/${_AuthParems.DB}`,
//         dispatch
//       );
//       if (res) {
//         await dispatch(
//           Modify_Product({
//             ProInfo: ProInfo,
//             Unit: res.ProUnit,
//             Index: Index,
//           })
//         );
//         await dispatch(ShowHide_Popup("IsPosPro"));
//       }
//     } catch (e) {
//       Show_Message(dispatch, e.message, "error");
//     } finally {
//       await Pre_Loading(dispatch, false);
//     }
//   };
//   const Remove_tableProduct = async (iIndex) => {
//     try {
//       const res = await API_POST(
//         `ProductTrans/Delete_tableProduct/`,
//         {
//           iRowIndex: iIndex,
//           iScrId: _Common.iScrId,
//           iALBillDiscId: _Common.iALBillDiscId,
//           iTaxCalcOnId: _Common.iTaxCalcOnId,

//           iTaxRelId: _HT.iTaxRelId,
//           iPartyId: _HT.iPartyId,
//           iVouchId: _HT.iVouchId,

//           iProId: 0,
//           iUnitId: 0,
//           dQty: 0,
//           dPriceRate: 0,
//           dDiscountPer: 0,
//           dDiscountAmt: 0,

//           strSearch: "",
//           strColumn: "",
//           strReason: "",
//           strJobId: "0",
//           strSetCurrentStatus: "",

//           strProAttDTId: "",
//           strStoAttDTId: "",
//           strTraAttDTId: "",
//           objItemRemark: {},
//           objRootCalc: {},

//           dAddLessDiscValue: _Disc.dALBillDisValue,
//           dTBillDiscPer: Number(_Disc.dBillDisPer),
//           dTBillDiscAmt: Number(_Disc.dBillDisAmt),
//           dCouponDiscPer: Number(_Disc.dCouponDiscPer),
//           dRewardPointper: Number(_Disc.dRewardPointper),
//           dCouponDiscAmt: Number(_Disc.dCouponDiscAmt),
//           dRewardPointAmt: Number(_Disc.dRewardPointAmt),

//           objPenCon: _DT.arrEntPenCon,
//           objBaseTransDT: _DT.arrEntDT,
//           objEntAddLess: _DT.arrEntAL,
//           objEntConRow: [],
//           objEntTax: _DT.arrEntTax,

//           iYearId: Number(_AuthParems.Year),
//           iBranchId: Number(_AuthParems.Branch),
//           strDBName: _AuthParems.DB,
//           iUserId: Number(_AuthParems.User),
//         },
//         dispatch
//       );
//       if (res) {
//         dispatch(Remove_product(res));
//       }
//     } catch (e) {
//       await Show_Message(dispatch, e.message, "error");
//     }
//   };

//   //#endregion

//   return (
//     <div className="container-pos">
//       <div className="pos-wrapper">
//         <div className="possection">
//           {!_Common.IsTabletMode && (
//             <div className="pos-itemlist">
//               <table className="product-table" ref={tableRef}>
//                 <thead>
//                   <tr>
//                     {_Common.arrtransper.map((dt, Index) => (
//                       <th
//                         key={Index}
//                         style={{
//                           minWidth: dt.colLen + "px",
//                           maxWidth: dt.colLen + "px",
//                         }}
//                       >
//                         {dt.aliasName}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {_DT.arrEntDT.map((product, trIndex) => (
//                     <tr
//                       key={trIndex}
//                       onClick={(e) => {
//                         View_ProductUnit(product, trIndex);
//                       }}
//                       onKeyDown={async (e) => {
//                         await e.preventDefault();
//                         if (e.key === "Enter") {
//                           View_ProductUnit(product, trIndex);
//                         } else table_keypress(e, trIndex);
//                       }}
//                     >
//                       {_Common.arrtransper.map((dt, tdIndex) => (
//                         <td
//                           key={tdIndex}
//                           style={{
//                             minWidth: dt.colLen + "px",
//                             maxWidth: dt.colLen + "px",
//                             whiteSpace: dt.isWordwrap ? "wrap" : "nowrap",
//                             textAlign: textalign[dt.textAlign - 1],
//                           }}
//                         >
//                           {dt.columnName === "proName" && (
//                             <>
//                               {`${product.proName}`}
//                               <br />
//                               <span>
//                                 GST - {numtodecimal(product.taxPer)} % | Unit :
//                                 {product.unitName}
//                               </span>
//                             </>
//                           )}
//                           {validatename(dt.columnName) === true && (
//                             <>
//                               {converttodecimal(
//                                 dt.datatype,
//                                 product[dt.columnName],
//                                 2
//                               )}
//                             </>
//                           )}
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//           {_Common.IsTabletMode && (
//             <>
//               {!isConvertReturn && (
//                 <div className="search-product">
//                   <div className="search-box">
//                     <input
//                       type="text"
//                       placeholder="Search Product or Scan Barcode Press F1 to Search"
//                       defaultValue={strSearch}
//                       onClick={(e) => dispatch(ShowHide_Popup("IsProSearch"))}
//                       onKeyDown={(e) => {
//                         if (e.key === "ArrowDown" || e.key === "ArrowUp") {
//                           $("[tabindex=0]").focus();
//                         }
//                       }}
//                       autoFocus
//                       autoComplete="off"
//                       id="pro-search"
//                     />
//                     <i className="fa-solid fa-magnifying-glass"></i>
//                   </div>
//                 </div>
//               )}
//               {isConvertReturn && (
//                 <h3 className="return-product">Product Return</h3>
//               )}
//               <MobileProductSearch />
//             </>
//           )}
//           <div className="pos-footer">
//             <div className="info">
//               <h2 className="infoheader">LAST BILL INFO</h2>
//               <ul>
//                 <li>
//                   <p>Inv No :</p>
//                   <p>{_Common.LastInvNo}</p>
//                 </li>
//                 <li>
//                   <p>Paid Amt : </p>
//                   <p>
//                     {new Intl.NumberFormat("en-GB", {
//                       style: "currency",
//                       currency: "INR",
//                     }).format(_Common.dLBPaidAmt)}
//                   </p>
//                 </li>
//                 <li>
//                   <p>Pay Type : </p>
//                   <p>{_Common.LasBillType}</p>
//                 </li>
//                 <li>
//                   <p>Net Amt : </p>
//                   <p>
//                     {new Intl.NumberFormat("en-GB", {
//                       style: "currency",
//                       currency: "INR",
//                     }).format(_Common.dLBNetAmt)}
//                   </p>
//                 </li>
//                 <li>
//                   <p>Balance : </p>
//                   <p>
//                     {new Intl.NumberFormat("en-GB", {
//                       style: "currency",
//                       currency: "INR",
//                     }).format(_Common.dLBBalAmt)}
//                   </p>
//                 </li>
//                 <li>
//                   <p>Inv Date : </p>
//                   <p>{_Common.LastInvDate}</p>
//                 </li>
//               </ul>
//             </div>
//             <div className="pos-btn-grp">
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 onClick={(e) => setisOtherCharges(!isOtherCharges)}
//               >
//                 Other Charges
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 onClick={(e) => setisDiscount(!isDiscount)}
//               >
//                 Discount
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 onClick={(e) => setisDelivery(!isDelivery)}
//               >
//                 Delivery
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={_DT.arrEntDT.length > 0 ? false : true}
//                 onClick={(e) => setisAddNotes(!isAddNotes)}
//               >
//                 Notes
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 disabled={Number(_HT.iVouchId) === 0 ? true : false}
//                 onClick={(e) => {
//                   if (Number(_HT.iVouchId) === 0) {
//                     Show_Message(
//                       dispatch,
//                       "Please Select Voucher to Delete!",
//                       "info"
//                     );
//                   } else {
//                     Ask_Question(
//                       dispatch,
//                       _Common.iScrId === 96 ? Delete_Return : Delete_Invoice,
//                       `Do You Want to Delete  ${
//                         _Common.iScrId === 96 ? "Return" : "Invoice"
//                       } ?`,
//                       true
//                     );
//                   }
//                 }}
//               >
//                 Delete&nbsp;<i className="bx bx-trash-alt"></i>
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 onClick={(e) => setisReturn(!isReturn)}
//               >
//                 Return
//               </button>
//               <button
//                 className="btn-fabgreen"
//                 onClick={(e) => setisPosView(!isPosView)}
//               >
//                 View &nbsp;<i className="fas fa-eye"></i>
//               </button>
//             </div>
//           </div>
//         </div>
//         <div className="possection">
//           <div className="profile_view">
//             <h1>{_Common.strScrName}</h1>
//             <span className="profile-icon">
//               <i
//                 className="bx bx-cog"
//                 onClick={(e) => dispatch(ShowHide_Popup("IsRightMenu"))}
//               ></i>
//             </span>
//           </div>
//           <div className="card party">
//             <h2>Name : {_Customer.PartyName}</h2>
//             <h2>Mobile : {_Customer.Mobile}</h2>
//             {!isConvertReturn && (
//               <span onClick={(e) => dispatch(ShowHide_Popup("IsPOSCustomer"))}>
//                 <i className="fa-solid fa-user-plus"></i>
//               </span>
//             )}
//           </div>
//           <div className="card staff">
//             <h2>Billing Staff</h2>
//             <div className="st">
//               <i
//                 className="fa-solid fa-user-tie"
//                 onClick={(e) => dispatch(ShowHide_Popup("IsEmployee"))}
//               ></i>
//               <sub>+</sub>
//             </div>
//             <div className="text">
//               <label>
//                 {_Employee.strEmployeeName} <br />
//                 <span>{_Employee.strEmpRole}</span>
//               </label>
//               <label>Reward Point : {_Employee.dRewardPoint}</label>
//             </div>
//           </div>
//           <div className="card sum">
//             <h2>Summary</h2>
//             <div className="text">
//               <p>Sub Total</p>
//               <p>
//                 {new Intl.NumberFormat("en-GB", {
//                   style: "currency",
//                   currency: "INR",
//                 }).format(Number(_Sum.GoodsValue))}
//               </p>
//             </div>
//             <div className="text">
//               <p>GST</p>
//               <p>
//                 {new Intl.NumberFormat("en-GB", {
//                   style: "currency",
//                   currency: "INR",
//                 }).format(Number(_Sum.Tax))}
//               </p>
//             </div>
//             <div className="text">
//               <p>Discount</p>
//               <p>
//                 {new Intl.NumberFormat("en-GB", {
//                   style: "currency",
//                   currency: "INR",
//                 }).format(Number(_Sum.Discount))}
//               </p>
//             </div>
//             {_Disc.strCoupon.length > 0 && (
//               <div className="text">
//                 <p
//                   style={{
//                     width: "100%",
//                     color: "green",
//                     fontSize: "12px",
//                     textAlign: "right",
//                   }}
//                 >
//                   {_Disc.dCouponDiscPer + _Disc.dCouponDiscAmt}% Coupon Discount
//                   Applied
//                 </p>
//               </div>
//             )}
//             <div className="text">
//               <p>Other Charges</p>
//               <p>
//                 {new Intl.NumberFormat("en-GB", {
//                   style: "currency",
//                   currency: "INR",
//                 }).format(Number(_Sum.AddLess))}
//               </p>
//             </div>
//             <div className="text">
//               <p>Round Off</p>
//               <p>
//                 {new Intl.NumberFormat("en-GB", {
//                   style: "currency",
//                   currency: "INR",
//                 }).format(Number(_Sum.RoundOff))}
//               </p>
//             </div>
//             <div className="text">
//               <p>
//                 TOTAL
//                 <br />
//                 <span>
//                   (Item : {_DT.arrEntDT.length},Qty : {_Sum.Qty})
//                 </span>
//               </p>
//               <p>
//                 {new Intl.NumberFormat("en-GB", {
//                   style: "currency",
//                   currency: "INR",
//                 }).format(Number(_Sum.NetAmt))}
//               </p>
//             </div>
//           </div>
//           <div className="card">
//             <h2>Payment</h2>
//             <div className="Payment" id="btn-paymt">
//               <button
//                 onClick={(e) => Update_PaymentMode(2)}
//                 className="icon active"
//                 onKeyDown={(e) => {
//                   if (e.key === "ArrowLeft") Update_PaymentMode(8);
//                   if (e.key === "ArrowRight") Update_PaymentMode(6);
//                 }}
//               >
//                 <i className="fa-solid fa-indian-rupee-sign"></i>
//               </button>
//               <button
//                 onClick={(e) => Update_PaymentMode(6)}
//                 className="icon"
//                 onKeyDown={(e) => {
//                   if (e.key === "ArrowLeft") Update_PaymentMode(2);
//                   if (e.key === "ArrowRight") Update_PaymentMode(4);
//                 }}
//               >
//                 <i className="fa-regular fa-credit-card"></i>
//               </button>
//               <button
//                 className="icon"
//                 onClick={(e) => Update_PaymentMode(4)}
//                 onKeyDown={(e) => {
//                   if (e.key === "ArrowLeft") Update_PaymentMode(6);
//                   if (e.key === "ArrowRight") Update_PaymentMode(7);
//                 }}
//               >
//                 <i className="fa-solid fa-building-columns"></i>
//               </button>
//               <button
//                 className="icon"
//                 onClick={(e) => Update_PaymentMode(7)}
//                 onKeyDown={(e) => {
//                   if (e.key === "ArrowLeft") Update_PaymentMode(4);
//                   if (e.key === "ArrowRight") Update_PaymentMode(8);
//                 }}
//               >
//                 <i className="fa-solid fa-wallet"></i>
//               </button>
//               <button
//                 className="icon"
//                 onClick={(e) => Update_PaymentMode(8)}
//                 onKeyDown={(e) => {
//                   if (e.key === "ArrowLeft") Update_PaymentMode(7);
//                   if (e.key === "ArrowRight") Update_PaymentMode(2);
//                 }}
//               >
//                 <p>UPI</p>
//               </button>
//             </div>
//           </div>
//           <div className="pos-sum-btn">
//             <button
//               className="btn-fabgreen"
//               ref={buttonclear}
//               onClick={CancelInvoice}
//             >
//               <span>
//                 <i className="fa-solid fa-eraser mr-2"></i> Clear Invoice
//               </span>
//             </button>
//             <button
//               className="btn-fabgreen"
//               ref={buttonsave}
//               disabled={_DT.arrEntDT.length > 0 ? false : true}
//               onClick={(e) => {
//                 if (_DT.arrEntDT.length === 0) {
//                   Show_Message(dispatch, "Atleast one Item Required", "info");
//                 } else if (_HT.iBillTypeId === 0) {
//                   Show_Message(dispatch, "Bill Type is Required ", "info");
//                 } else {
//                   Ask_Question(
//                     dispatch,
//                     _Common.iScrId === 96 ? Save_Return : Show_Receipt,
//                     `Do You Want to Save  ${
//                       _Common.iScrId === 96 ? "Return" : "Invoice"
//                     }?`
//                   );
//                 }
//               }}
//             >
//               <span>
//                 <i className="fa-regular fa-floppy-disk mr-2"></i>
//                 {_Common.iScrId === 96 ? "Save Return" : "Save Invoice"}
//               </span>
//             </button>
//           </div>
//         </div>
//         {_Common.IsRightMenu && <Posrightmenu />}
//         {_Common.IsPOSCustomer && <CustomerSearch />}
//         {_Common.IsEmployee && <StaffProfile />}
//         {_Common.IsPosPro && <PosproductInput />}
//         {_Common.IsProRemark && <ItemRemarks />}
//         {_Common.IsProCal && <RootCalculation />}
//         {_Common.IsSession && (
//           <Sessionopenclose SessionOpen={Load_PosInvoice} />
//         )}
//         {_Common.IsProSearch && (
//           <TransProductSearch View_Product={Add_NewProduct} />
//         )}
//         {_Common.IsBatchPro && (
//           <BatchProductSearch View_Product={Add_NewProduct} />
//         )}
//         {_Common.IsAttPro && (
//           <AttributeProductSearch View_Product={Add_NewProduct} />
//         )}
//         {isReceipt && (
//           <Receipt
//             Close={(e) => setisReceipt(!isReceipt)}
//             PayMode={Number(_HT.iBillTypeId)}
//             NetAmt={Number(_Sum.NetAmt)}
//             Save_Invoice={(e) => Save_Invoice(e)}
//           />
//         )}
//         {isDelivery && (
//           <DeliveryOption Close={(e) => setisDelivery(!isDelivery)} />
//         )}
//         {isPosView && (
//           <PosView
//             Close={(e) => setisPosView(!isPosView)}
//             ViewInvoice={Add_NewProduct}
//             Return={(PosInvId) => {
//               setisPosView(!isPosView);
//               setisProReturn(!isProReturn);
//               setiVouchId(PosInvId);
//             }}
//           />
//         )}

//         {isReturn && (
//           <POSReturn
//             Close={(e) => setisReturn(!isReturn)}
//             View_Return={() => {
//               setisReturn(!isReturn);
//               setisConvertReturn(!isConvertReturn);
//             }}
//           />
//         )}
//         {isProReturn && (
//           <ProductReturn
//             Close={(e) => {
//               setiVouchId(0);
//               setisProReturn(!isProReturn);
//             }}
//             VouchId={iVouchId}
//             View_Return={(arrperm) => {
//               setiVouchId(0);
//               setisConvertReturn(!isConvertReturn);
//               setisProReturn(!isProReturn);
//               setarrEntPermission(arrperm);
//             }}
//           />
//         )}
//         {isOtherCharges && (
//           <OtherCharges Close={(e) => setisOtherCharges(!isOtherCharges)} />
//         )}
//         {isDiscount && <Discount Close={(e) => setisDiscount(!isDiscount)} />}
//         {isAddNotes && <Notes Close={(e) => setisAddNotes(!isAddNotes)} />}
//         <Messagedialogbox />
//       </div>
//     </div>
//   );
// }
// export default Pointofsales;